<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-1">
        <i class="far fa-newspaper"></i> What&apos;s New
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-1">
        <div class="whats-new-upcoming m-4" v-if="false">
          <strong><i class="far fa-info-circle" /> Upcoming</strong>
          <p></p>
        </div>

        <WhatsNewGroup title="Recent Updates" :defaultOpen="true">
          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - June</ContentTitle>
              <ContentSubTitle>22/06/2026</ContentSubTitle>
              <ContentSubTitle>v3.1.6</ContentSubTitle>
              <strong>General</strong>
              <ul>
                <li>Minor fixups and improvements</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Added filters to production tree in config &amp; station app view</li>
              </ul>
              <strong>Analytics</strong>
              <ul>
                <li>Removed Order IFOT breakdowns. Replaced by DIFOT analytics</li>
              </ul>
              <strong>Task</strong>
              <ul>
                <li>Fixed an issue with removing loaded panels from tasks when they&apos;re back in production</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Improved click detection between vertices and square angles</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>
        </WhatsNewGroup>

        <WhatsNewGroup title="2026">
          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - June</ContentTitle>
              <ContentSubTitle>18/06/2026</ContentSubTitle>
              <ContentSubTitle>v3.1.5</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Fixed issue with sorting panel stage task list report</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Added 'scheduled' reporting code for late orders</li>
                <li>Added stricter checks for scanning stock that doesn&apos;t exist for stock transfer task items</li>
              </ul>
              <strong>Production Station</strong>
              <ul>
                <li>Added ability to scan in the inventory bin barcode when assigning inventory bins for stations</li>
              </ul>
              <strong>Inventory</strong>
              <ul>
                <li>Added limits of moving stock between inventory bins where stock does not exist</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - June</ContentTitle>
              <ContentSubTitle>17/06/2026</ContentSubTitle>
              <ContentSubTitle>v3.1.4</ContentSubTitle>
              <strong>Inventory</strong>
              <ul>
                <li>Fixed issue with editing inventory bins</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Fixed issue scanning assemblies in production station</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - June</ContentTitle>
              <ContentSubTitle>07/06/2026</ContentSubTitle>
              <ContentSubTitle>v3.1.3</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Fixed up capacity display for station capacity chart in production</li>
                <li>Added support for templates / assemblies in NCR order item report</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - May</ContentTitle>
              <ContentSubTitle>28/05/2026</ContentSubTitle>
              <ContentSubTitle>v3.1.2</ContentSubTitle>
              <strong>DIFOT</strong>
              <ul>
                <li>Added customer late payment operational code</li>
                <li>Added notes to difot order list report</li>
                <li>Improved reporting code calculation for stock-only orders</li>
                <li>Fixed up DIFOT summary data that was including older orders before reporting was enabled</li>
                <li>Added notes display to runsheet list for operational reporting</li>
                <li>NCR orders now included in DIFOT reporting</li>
              </ul>
              <strong>NCR</strong>
              <p>NCR orders previously used a zero lead time rule for both production &amp; despatch to ensure NCRs were completed ASAP.<br />
              Now, NCR orders have more control over lead time rules.</p>
              <ul>
                <li>NCR orders now use a single production setting to allow control of total production lead time allocated to NCRs</li>
                <li>NCR orders now use lead time from despatch method as per regular orders</li>

                <li>Added option in production settings to control the <strong>total</strong> production lead time for NCR orders.<br />
                Defaults to 0mins, which matches the current behaviour of NCRs due ASAP</li>
                <li>Removed option to set/edit a requested date for NCR orders</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Added support for displaying panel labels. Toggled on the top toolbar</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - May</ContentTitle>
              <ContentSubTitle>20/05/2026</ContentSubTitle>
              <ContentSubTitle>v3.1.1</ContentSubTitle>
              <strong>Accounts</strong>
              <ul>
                <li>Increased decimal place handling for credit note pre-tax credit amount.<br />
                Please note Xero/MYOB still apply rounding on GST calculations</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Fixed issues with arcs on certain complex shapes not producing correct cutting paths</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <ContentTitle>Major Update - May</ContentTitle>
              <ContentSubTitle>18/05/2026</ContentSubTitle>
              <ContentSubTitle>v3.1.0</ContentSubTitle>
              <strong>DIFOT - Delivered In-Full On-Time</strong>
              <p>
                This update features a new reporting feature integrated into orders &amp; task system to accurately track if orders were completed in-full on-time or report on why they missed the estimated date.<br />
                Reporting is based around the despatch manager using report codes to flag reasons why an order was not completed in-full on-time.<br />
                To turn on this feature, please configure the delivery task type to enable operational reporting as well as review the additional settings mentioned below for operation reporting.
              </p>
              <strong>Tasks</strong>
              <ul>
                <li>Added operational reporting category to flag despatch tasks as either outbound (ie, delivery) or collection (ie, pickup)</li>
                <li>Added operational reporting option to enable/disable operational reporting when creating/updating despatch tasks</li>
                <li>Added operational reporting settings to task types for the dashboard</li>
                <li>Task items now require operational reporting per order (if op reporting is configured) during task creation</li>
                <li>Details step for new tasks now moved to front to assist with operational reporting</li>
              </ul>
              <strong>App</strong>
              <ul>
                <li>Added support for operational reporting when scanning in new orders to a task</li>
              </ul>
              <strong>Analytics</strong>
              <ul>
                <li>New DIFOT dashboard created to track all orders completed</li>
                <li>Added DIFOT analytics permission to access DIFOT dashboard</li>
                <li>Added DIFOT order list report to show all orders with their DIFOT status and reason codes</li>
                <li>Stock with tracking quantities disabled no longer show up in purchasing reports</li>
              </ul>
              <strong>Optimiser</strong>
              <ul>
                <li>Fixed up display of order customer reference when clicking on optimiser sheet panels in the editor</li>
                <li>Fixed panel trim around large arcs</li>
              </ul>
              <strong>Purchasing</strong>
              <ul>
                <li>Fixed rare issue with purchase order received items doubling up</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - April</ContentTitle>
              <ContentSubTitle>26/04/2026</ContentSubTitle>
              <ContentSubTitle>v3.0.12</ContentSubTitle>
              <strong>Optimiser</strong>
              <ul>
                <li>Orders that revert back to a pending approval status are now removed from optimiser sheets</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Fixed rare issue with cutouts connecting to large, shallow arcs not being detected correctly</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Station overview status now ignores panels from orders that reverted back to a pending approval status</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - April</ContentTitle>
              <ContentSubTitle>15/04/2026</ContentSubTitle>
              <ContentSubTitle>v3.0.11</ContentSubTitle>
              <strong>Optimiser</strong>
              <ul>
                <li>Improved click detection on panel cutouts in the optimiser editor that was preventing certain panels from being selected</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Start of support for operational reporting in tasks. Reporting option added to task types</li>
              </ul>
              <strong>MYOB</strong>
              <ul>
                <li>Improved display of the MYOB Integration info panel for items not synced to MYOB with more information</li>
                <li>Added support to relink a contact to another MYOB contact</li>
                <li>Added support to force a contact resync to MYOB if possible</li>
                <li>Added support to force an invoice resync to MYOB if possible. <br />Please <strong>verify</strong> with MYOB after forcing a sync to ensure duplicates are not present</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - April</ContentTitle>
              <ContentSubTitle>12/04/2026</ContentSubTitle>
              <ContentSubTitle>v3.0.10</ContentSubTitle>
              <strong>Inventory</strong>
              <ul>
                <li>Added option for assemblies to unlock the unit price by default when added to orders</li>
              </ul>
              <strong>Accounts</strong>
              <ul>
                <li>Added support to update invoiced date on invoices. Note that this will require manual updating of the linked invoice in Xero or MYOB</li>
              </ul>
              <strong>Contacts</strong>
              <ul>
                <li>Added warning details for contacts with both customer and supplier roles when MYOB integration is enabled.<br />
                Due to MYOB limitations, this is a requirement of contacts that share both roles.</li>
              </ul>
              <strong>Purchasing</strong>
              <ul>
                <li>Added support to set the stock container on bulk purchase orders</li>
                <li>Various updates to purchasing reports</li>
                <li>Added tools to modify container purchasing reports</li>
              </ul>
              <strong>Analytics</strong>
              <ul>
                <li>Added Late Arrivals charts for location based tasks in Tasks dashboard</li>
                <li>Added On Site charts for location based tasks in Tasks dashboard</li>
                <li>Added daily charts for tasks in Tasks dashboard</li>
                <li>Added task item list report</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Added support for additional surcharge items for orders. Found in order configuration</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Added additional scan info to the main panel popup in production stations</li>
              </ul>
              <strong>Xero</strong>
              <ul>
                <li>Added support to unlink an overpayment, invoice and credit note items and their allocations from Xero.<br />This will result in a new overpayment, invoice or credit note being created in Xero. Please <strong>only</strong> use to fix internal Xero issues</li>
                <li>Added support to force sync an invoice &amp; credit note to Xero. Available when an item has sync errors with Xero.<br />Please <strong>verify</strong> with Xero after forcing a sync to ensure duplicates are not present</li>
                <li>Improved some Xero sync activity log items</li>
                <li>Added reference field to Overpayments in Xero</li>
                <li>Added support for accessing Overpayments in Xero via 'View Item'</li>
                <li>Improved display of the Xero Integration info panel for items not synced to Xero with more information</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - March</ContentTitle>
              <ContentSubTitle>11/03/2026</ContentSubTitle>
              <ContentSubTitle>v3.0.9</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Updates to include area for daily production stage bar chart</li>
                <li>Updates to options for auto purchasing reports</li>
              </ul>
              <strong>Inventory</strong>
              <ul>
                <li>Purchasing options added to glass sizes for purchasing reports</li>
                <li>Fixed issue with editing assembly templates</li>
              </ul>
              <strong>Optimiser</strong>
              <ul>
                <li>Added fix for rare issue with invalid cutouts in panels on optimiser sheets</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Updates to handling center cutouts in DXF imports</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Added fix for preview link on send order dialog to include pricing option</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Added fix for selecting default users that were archived</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - February</ContentTitle>
              <ContentSubTitle>18/02/2026</ContentSubTitle>
              <ContentSubTitle>v3.0.8</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Updates to sales order summary report</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Added option to include diagrams in order production sheet documents</li>
                <li>Added option to include customer copy in order production sheet documents</li>
              </ul>
              <strong>General</strong>
              <ul>
                <li>General readability updates to PDF documents</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - February</ContentTitle>
              <ContentSubTitle>16/02/2026</ContentSubTitle>
              <ContentSubTitle>v3.0.7</ContentSubTitle>
              <strong>Users</strong>
              <ul>
                <li>Added activity log display for users</li>
                <li>Added activity log display for user groups</li>
                <li>General improvements to activity logging for users system</li>
                <li>Fixes to permissions editing</li>
              </ul>
              <strong>General</strong>
              <ul>
                <li>General UI Updates</li>
                <li>Updated sanitizing in email address input boxes</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - February</ContentTitle>
              <ContentSubTitle>10/02/2026</ContentSubTitle>
              <ContentSubTitle>v3.0.6</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Updates to stock automatic purchasing reports</li>
                <li>Added supplier purchase order performance chart</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Added auto-scrolling for scanning panels into the station</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Added Fit Arcs tool for selection. This converts a series of connected lines into a single arc if possible</li>
                <li>Added Square Off tool for selection. This squares off a selection of lines in a corner</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Updates to main task manager filtered list</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Added support for auto complete flag on production stages</li>
                <li>Panels due at stages with auto complete enabled will automatically be marked as completed when completing the previous stage</li>
              </ul>
              <strong>Inventory</strong>
              <ul>
                <li>Fixed creation date filtering on glass block list</li>
                <li>Fixed new block dialog not showing suppliers</li>
                <li>Added support to print all glass block labels from the filtered list. Action button is available in the toolbar, left of the new block button</li>
              </ul>
              <strong>General</strong>
              <ul>
                <li>Small updates to filtered data tables used throughout the system</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - February</ContentTitle>
              <ContentSubTitle>04/02/2026</ContentSubTitle>
              <ContentSubTitle>v3.0.5</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Updates to stock automatic purchasing reports</li>
                <li>Updates to supplier performance report</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - February</ContentTitle>
              <ContentSubTitle>02/02/2026</ContentSubTitle>
              <ContentSubTitle>v3.0.4</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Updates to stock automatic purchasing reports</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Fix for edgework allowance calculations on line items</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>       
          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - January</ContentTitle>
              <ContentSubTitle>29/01/2026</ContentSubTitle>
              <ContentSubTitle>v3.0.3</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Updates to stock automatic purchasing reports</li>
              </ul>
              <strong>Optimiser</strong>
              <ul>
                <li>Fixed rare issue where the trim around a panel would have an extra 1mm added for panels containing large arcs / circles</li>
              </ul>
              <strong>Editor</strong>
              <ul>
                <li>Added support for editing angles within panels</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - January</ContentTitle>
              <ContentSubTitle>22/01/2026</ContentSubTitle>
              <ContentSubTitle>v3.0.2</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Added Order Item report in Orders</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - January</ContentTitle>
              <ContentSubTitle>20/01/2026</ContentSubTitle>
              <ContentSubTitle>v3.0.1</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Improved accuracy of COGS in glass sales order summary report</li>
                <li>Added NCR completed date to NCR detailed report</li>
                <li>Added quantities to NCR detailed report</li>
                <li>NCR reports updated to be based on order completed date</li>
                <li>NCR Order item chart now uses quantities instead of order item counts</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Fixed issues with panels requiring transfer that were recut</li>
                <li>Added order type to production item list</li>
              </ul>
              <strong>Task</strong>
              <ul>
                <li>External transfer task items are now displayed in the customer delivery sheet</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>          
          <div class="row">
            <div class="col-12">
              <ContentTitle>Major Update - January</ContentTitle>
              <ContentSubTitle>18/01/2026</ContentSubTitle>
              <ContentSubTitle>v3.0.0</ContentSubTitle>
              <strong>Order Editor</strong>
              <ul>
                <li>Fixed an issue when creating a custom edge cutout would sometimes create a cutout that was flipped</li>
                <li>Added 1 decimal place precision for editing various dimensions</li>
                <li>Moved shape tools on the shape options dialog to its own tab in the editor</li>
                <li>Added additional tools for shapes to automatically adjust the points. These tools are recommended to be used to cleanup imported DXF. Please verify the shapes after using the tools</li>
                <li>Added mirror vertical &amp; horizontal options to the shape tools</li>
                <li>Added expand &amp; shrink options to the shape tools</li>
                <li>Added snap points to grid option to the shape tools. This snaps all points to nearest millimetre on the grid</li>
                <li>Added cleanup points option to the shape tools. This removes redundant points from the shape</li>
                <li>Added correct rotation option to the shape tools. This corrects the rotation of the shape to align the bottom edge horizontally</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Fixed issue when setting up an order&apos;s external purchase orders would fail when an external item was cancelled</li>
              </ul>
              <strong>Contacts</strong>
              <ul>
                <li>Export options added to archived contacts list</li>
                <li>Added supplier / container list for purchase order notes for container purchase tool</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Updated production stage details page</li>
                <li>Added target rate settings for production stages for analytics</li>
                <li>Added day count label for due dates on panel schedule in production stations</li>
                <li>Added lead time calculation type for production stages. Lead time can be static (as before) or dynamic based on average processing time for the stage</li>
                <li>Dynamic lead time uses current capacity for stations and dynamically adjusts lead times to reflect current workloads</li>
                <li>Added dynamic lead time warning threshold. If crossed, new orders will display a warning that production is over capacity and lead times have changed</li>
              </ul>
              <strong>Optimiser</strong>
              <ul>
                <li>Fixed issue with edgework not being displayed correctly on some panels with small rounded corners in optimiser sheet editor</li>
                <li>Fixed issue with split sheets automatically rotated on optimiser station not correctly rotating split lines</li>
              </ul>
              <strong>Inventory</strong>
              <ul>
                <li>Changed glass size reorder level to required days of stock setting for new purchasing reports</li>
              </ul>
              <strong>Purchasing</strong>
              <ul>
                <li>Added action automation component to get containers requiring purchasing from the container purchasing report</li>
                <li>Added branch automation component to go through required container purchases</li>
              </ul>
              <strong>Accounts</strong>
              <ul>
                <li>Improved sorting of invoice list in customer account balance documents</li>
                <li>Fixed rare issue with customer credit balance not adjusting correctly for active orders invoiced early and with payments attached</li>
                <li>Fixed issue with overpayment allocation dialog showing incorrect available available amount if some amounts are reserved to orders</li>
              </ul>
              <strong>Analytics</strong>
              <ul>
                <li>Added contact filter to NCR charts</li>
                <li>Added NCR charts to individual contact dashboard</li>
                <li>Added customer price list override report</li>
                <li>Added production capacity summary to production dashboard</li>
                <li>Added order completed In-Full On-Time summary to order dashboard</li>
                <li>Added contact order value variation chart to analytics contact dashboard</li>
                <li>Minimum spend report no longer hides contacts that met the minimum spend amount</li>
                <li>Contact Account manager now copied to new orders for analytics</li>
                <li>Added analytics dashboard to individual glass service stock pages</li>
                <li>Added analytics dashboard to individual general stock pages</li>
                <li>Added NCR percent to NCR breakdown</li>
                <li>Added supplier to incoming stock on purchasing dashboard</li>
                <li>Added stock purchasing report to assist with purchase planning</li>
                <li>Added supplier purchasing performance report</li>
                <li>Added orders in draft status warning count to home page overview</li>
                <li>Added container purchasing helper tool in purchasing analytics</li>
              </ul>
              <strong>General</strong>
              <ul>
                <li>Improved readability of page header for all PDF generated documents</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>
        </WhatsNewGroup>

        <WhatsNewGroup title="2025">
          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - November</ContentTitle>
              <ContentSubTitle>13/11/2025</ContentSubTitle>
              <ContentSubTitle>v2.9.10</ContentSubTitle>
              <strong>Pricing</strong>
              <ul>
                <li>Added minimum per-item price setting for stock and price groups</li>
                <li>Updated price editing to differentiate between per-item minimum price and per-group minimum price</li>
                <li>Minimum per-item price is applied per item in the order item list. This also counts towards the groups price</li>
                <li>Minimum per-group price is applied once per group in the order item list. A group is defined as the top level item (eg, glass) and all its child items (eg, services)</li>
                <li>Updated customer price list PDFs to show the minimum per-item price and minimum per-group prices</li>
              </ul>
              <strong>Purchasing</strong>
              <ul>
                <li>Added ability to edit despatch type on purchase orders</li>
              </ul>
              <strong>Inventory</strong>
              <ul>
                <li>Fixed up assembly item editing</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Added shape dimensions to production panels on the waterjet bed</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Fixed issues with task type default stock items</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Fixed rare issue when editing order items that would revert changes if an error occurred during submitting the edits</li>
                <li>Fixed issue with recovering orders</li>
              </ul>
              <strong>Analytics</strong>
              <ul>
                <li>Added average units per panel in the daily panels production chart</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - November</ContentTitle>
              <ContentSubTitle>09/11/2025</ContentSubTitle>
              <ContentSubTitle>v2.9.9</ContentSubTitle>
              <strong>Stocktaking</strong>
              <ul>
                <li>Stocktake system has had a refresh with general improvements to the process</li>
                <li>Added assigned user support to stocktakes. Only the assigned users, stocktake creator or users with stocktake approval can submit counts</li>
                <li>Assigned users get push notifications for stocktake updates</li>
                <li>Added ability to edit basic stocktake details</li>
                <li>Added account location to stocktakes</li>
                <li>Moved stocktake actions to the main dropdown menu to match other pages</li>
                <li>Offcuts are now supported in stocktakes &amp; each one must be scanned in if enabled. By default, offcuts are disabled</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Stock transfer tab now hidden in new task dialog if only 1 active account location is available</li>
                <li>Added task description to main task page</li>
                <li>Added option to task types to allow 'None' to be selected for despatch stock in orders</li>
                <li>Added support for custom labels on tasks</li>
                <li>Updated calendar styling</li>
                <li>Added option in task types to allow kiosk self-loading</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Added grace period setting to toughening batches to allow panels to be scanned in after batch expiry without warnings for a short period of time. Defaults to 30mins</li>
                <li>Added today&apos;s recut count to station summary graph</li>
              </ul>
              <strong>Optimiser</strong>
              <ul>
                <li>Added warnings to sheets in the editor when cutting</li>
                <li>Currently displays warnings if small waste pieces are detected smaller than allowable panel trim</li>
                <li>Sheets are no longer automatically completed when all allocations are completed. Now, a finish button is displayed to allow the user to confirm completion</li>
              </ul>
              <strong>Analytics</strong>
              <ul>
                <li>Moved order production summary widget to main overview dashboard</li>
                <li>Added logged user to recut panel table</li>
              </ul>
              <strong>Inventory</strong>
              <ul>
                <li>Added support to update basic details on a glass block</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Added filters to show partially invoiced orders</li>
                <li>Added status label to show partially invoiced orders in order list</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Fixed some issues with seperate tool causing panels to have incorrect shaped cuts for optimiser</li>
              </ul>
              <strong>Admin</strong>
              <ul>
                <li>Added a moving average calculator tool under Admin &gt; Tools to help with manual moving average adjustments</li>
              </ul> 
              <strong>App</strong>
              <ul>
                <li>Updates to stocktake process</li>
                <li>Added task description to task info boxes</li>
                <li>Added production list to order item details page for task load in</li>
                <li>Added display of the labels for a task</li>
                <li>Support for self-loading in kiosk if option is set</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.9.8</ContentTitle>
              <ContentSubTitle>08/10/2025</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Added daily &amp; monthly usage charts on the stock item dashboard</li>
                <li>Added account manager charts for order value/counts</li>
                <li>Fixed daily usage chart for stock items where purchase orders were due in the past</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Added 'Not Invoiced' filter to order list</li>
              </ul>
              <strong>Optimiser</strong>
              <ul>
                <li>Fixed rare issue when printing offcut labels at optimiser cutting station</li>
              </ul>
              <strong>Accounts</strong>
              <ul>
                <li>Updated reserved / available amounts display for overpayments</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Production items that cannot be completed due to production rules, can now be completed by a user with production manager permissions</li>
                <ul><li>This feature requires scanning a panel at a production station while logged in as a user with production manager permissions</li></ul>
                <li>Added more settings &amp; readings to toughening batch entry screen</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.9.7</ContentTitle>
              <ContentSubTitle>16/09/2025</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Charts/Tables using incoming stock now also use purchase orders in pending confirmation status</li>
                <li>Updates and fixes to daily stock level/projection chart</li>
                <li>Fixes to stock charts on the stock summary dashboard page</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Fixed issue with panel size calculation</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.9.6</ContentTitle>
              <ContentSubTitle>15/09/2025</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Added production item session tracking for items processing through production</li>
                <li>Added production lean manufacturing metrics based on item sessions</li>
                <li>Added production session time chart</li>
                <li>Changed recut report to be a detailed filtered data table with export options</li>
                <li>Changed NCR report to be a detailed filtered data table with export options</li>
                <li>Added sales tax info for invoice detailed report</li>
                <li>Added sales tax info for order detailed report</li>
                <li>Added treemap to inventory dashboard to visually display stock value, area or sheet values</li>
                <li>General cleanup for various reports &amp; widgets</li>
              </ul>
              <strong>Inventory</strong>
              <ul>
                <li>Added stock dashboard with analytics for glass stock</li>
                <li>Added ability to manually create new glass blocks</li>
                <li>Added ability to override glass size in manual stock adjustments for incoming sheets</li>
                <li>Updates to glass block list</li>
              </ul>
              <strong>Accounts</strong>
              <ul>
                <li>Fixed display of orders linked via Overpayments on the Payment Received page</li>
                <li>Added reserved payment amount column to Overpayments list</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Updated cutout handling process for the operator at optimiser</li>
                <li>Fixed group counts for optimiser sheet schedule</li>
                <li>Fixed group counts for panel schedule</li>
                <li>Fixed workflow when dragging in sheets in optimiser station</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Selecting glass stock sheets with grain direction now defaults to the correct grain direction</li>
                <li>Improved performance with oval shapes</li>
                <li>Improved performance with complex shapes</li>
                <li>Fixed issue with edgework detection on some semicircle shapes</li>
                <li>Fixed issues with cutting lines (in optimiser) not set in shapes with large arcs (eg, semicircles)</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Fixed issue with delivery address sometimes causing issues in NCR creation</li>
                <li>Order searching now includes searching by old quote references for orders converted from quotes</li>
                <li>Fixed issue with selecting offcuts that are not reserved in optimiser but are in the schedule</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Fixed issue with task manager map &amp; orders list</li>
                <li>Fixed issue with default stock item dropdown in task type dialog</li>
              </ul>
              <strong>General</strong>
              <ul>
                <li>Fixed issue with selecting only one date in date range filters</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.9.5</ContentTitle>
              <ContentSubTitle>13/08/2025</ContentSubTitle>
              <strong>Tasks</strong>
              <ul>
                <li>Adding orders on hold to a new task shows a warning in the run sheet that an order is on hold</li>
                <li>Tasks linked to orders on hold now go into pending approval status on task creation</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Fixed add payment dialog for orders to correctly show the current payment status</li>
                <li>Fixed issue with delivery items during order item editing</li>
                <li>Fixed issue with NCR approvals that generate a credit note</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Fixed calculation of edgeworks on edges that contain multiple small cutting paths</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.9.4</ContentTitle>
              <ContentSubTitle>06/08/2025</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Added Invoice Glass Summary Report</li>
                <li>Added Invoice Service Summary Report</li>
                <li>Added Invoice Value Summary Report</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Revered copy group button in order item list for templates</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.9.3</ContentTitle>
              <ContentSubTitle>03/08/2025</ContentSubTitle>
              <strong>Accounts</strong>
              <ul>
                <li>Updates to payment received receipt to correctly show overpayment reserved amounts for orders</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Reverted add service button on order items in the order item list</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Orders on hold are now hidden by default when creating new tasks</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.9.2</ContentTitle>
              <ContentSubTitle>31/07/2025</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Updates to daily order estimates report</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.9.1</ContentTitle>
              <ContentSubTitle>30/07/2025</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Rows with no data are now hidden from the glass stock value report</li>
                <li>Added CSV export option to Order Value Summary Reports</li>
                <li>Added daily order estimates report to order analytics dashboard</li>
                <li>Added ability to select multiple production stations in the Daily Capacity Production Station chart</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Import DXF function now displays warnings if any center cutout circles are overlapping</li>
                <li>Fixes for rare cases where edgeworks were not being detected correctly around cutouts that are slightly offset</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Major Update - v2.9.0</ContentTitle>
              <ContentSubTitle>18/07/2025</ContentSubTitle>
              <strong>Assemblies</strong>
              <ul>
                <li>Assembly stock types are now available</li>
                <li>Assemblies are powerful stock items that are a container for a nested group of produced items to produce a final assembled production. For example, IGUs</li>
                <li>Templates are still available, but we strongly recommend to use assembly stock types for double glazed / insulated glass units</li>
                <li>A new assembly production station &amp; stage type has been added with the ability to enter assemblies and build them using all the required items</li>
              </ul>
              <strong>Inventory</strong>
              <ul>            
                <li>Added ability to add documents to stock items in inventory</li>
                <li>Added production completable flag for general stock items. If set, will be required by assembly stages for scanning</li>
                <li>Added source sheet info to the offcut list on the stock page</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Assembly production stage &amp; station type added. Use these stations to build assembly from sub-items</li>
                <li>Production Panels are now known as production items, and can be assemblies or glass items</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Production panel summary in order production tab has been updated with sticky headers and scrolling</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Added assembly item on side bar to create assemblies in the order editor</li>
                <li>Assembly group object added to order editor to manage assemblies and the child glass items</li>
                <li>Only layered type of assemblies can be created via the order editor</li>
                <li>Improved the measure &amp; cutting tools when working around large arcs / circles</li>
              </ul>
              <strong>Pricing</strong>
              <ul>
                <li>Assembly tab added to price lists and price list configurations</li>
              </ul>
              <strong>Analytics</strong>
              <ul>
                <li>Fixed up issues with glass stock on hand report taking too long to load</li>
              </ul>
              <strong>Optimiser</strong>
              <ul>
                <li>Fixed issues with optimiser sheets with custom sizes not displaying correctly in the optimiser sheet list</li>
              </ul>
              <strong>Accounts</strong>
              <ul>
                <li>A new reserved payment system replaces the way Overpayments were linked to Pre-Paid / COD orders</li>
                <li>Overpayments in available status can now be allocated to one or more orders pending pre-paid / COD</li>
                <li>Credit Notes can now be allocated to one or more orders pending pre-paid / COD</li>
                <li>The reserved amount for orders will be transferred automatically to the invoice when an order is invoiced</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.8.7</ContentTitle>
              <ContentSubTitle>09/06/2025</ContentSubTitle>
              <strong>Orders</strong>
              <ul>
                <li>Fixed issue with editing order configuration settings</li>
                <li>Customer approval option on order items is now no longer available once an order has started production</li>
                <li>Send order button added to pending customer approval</li>
                <li>Fixed issue with despatch fee stock item getting reset to default item when selecting custom addresses for deliveries</li>
                <li>Fixed issue with copying despatch fee stock item after copying an order or creating an NCR</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Fixed issue where panels were occasionally scanned in twice via the app</li>
                <li>Task approval now only checks cash on delivery orders. Prepaid orders already require approval via orders system</li>
                <li>Tasks pending approval now show a badge on the main menu for requiring attention</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Barcode entry now automatically focused more often in batch cutting screen</li>
              </ul>
              <strong>Analytics</strong>
              <ul>
                <li>Contact minimum spend report now displays contacts on credit stop/hold</li>
              </ul>
              <strong>General</strong>
              <ul>
                <li>Badges on the main menu now dynamically update</li>
              </ul>
            </div>
          </div>
          <FormHorizontalRule />

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.8.6</ContentTitle>
              <ContentSubTitle>15/05/2025</ContentSubTitle>
              <strong>Orders</strong>
              <ul>
                <li>Default edgeworks setup in order editor used by order line items now attempts to use rectangle based shape type config</li>
                <li>Fixed an issue where cancelling orders &amp; charging production fees would cause an error in some instances</li>
              </ul>
              <strong>General</strong>
              <ul>
                <li>Fixed issue with unicode / emoji characters in uploaded document filenames</li>
              </ul>
            </div>
          </div>
          <FormHorizontalRule />

          <div class="row">
            <div class="col-12">
              <ContentTitle>Major Update - v2.8.5</ContentTitle>
              <ContentSubTitle>06/04/2025</ContentSubTitle>
              <strong>Orders &amp; Task Types</strong>
              <ul>
                <li>Orders are now linked directly to Task Types to add more control of the despatching of orders instead of the fixed Delivery / Pickup options</li>
                <li>By default, Delivery &amp; Pickup task types already exist and existing orders have been migrated to link to these types</li>
                <li>Additional Task Types can be created to allow more control over the order workflows. For example, orders that require installations, on-site quoting, etc</li>
              </ul>
              <strong>Despatch Charge Type</strong>
              <ul>
                <li>Orders can now be charged a despatch fee (eg, delivery fee) per order or per task. This allows 1 delivery fee for multiple orders despatched at the same time</li>
                <li>Order despatch charge type can be controlled per contact and per contact address</li>
                <li>Orders charged despatch fees per task will have the fee inserted into the first order in the task item on task item sign off</li>
                <li>The per task fee setting only applies when using the task system. This does not apply to orders manually despatched</li>
                <li>By default all contacts are charged per order</li>
              </ul>
              <br />
              <strong>Orders</strong>
              <ul>
                <li>Orders now have a drop down to select the task type for despatch types</li>
                <li>Order list now has task type filters instead of delivery/pickup despatch type filters</li>
                <li>Default delivery charge in order settings is now only used as NCR additional delivery charge setting</li>
                <li>Added ability to edit contact person for an order via edit order dialog</li>
                <li>Added buttons for easier order item creation</li>
                <li>Added ability to import a CSV file for new order creation for order items</li>
                <li>Orders pending Pre-paid / COD now displays override button on the main summary</li>
                <li>Orders with skipped / overidden pre-paid / COD now displays reasons in the payment area on the main summary</li>
                <li>Added support for custom field data for order items. These are displayed on the order sheets / emails and panel labels</li>
                <li>Added support for a custom field to be added to large production labels as an additional QR code</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Added toolbar item 'Convert' which allows conversion of line items into editor items for existing orders or NCRs</li>
                <li>Added ability to rotate a shape by 90 degrees</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Task Types now have a list of available service fee stock items to be used for orders. This has been migrated based on the delivery fee option in stock items</li>
                <li>Task Types have been modified to reflect the changes between orders and despatching</li>
                <li>The task list now has a tab for each active task type</li>
                <li>Fixed issue with updating pickup type tasks giving an error about null user</li>
                <li>Fixed issues related to creating new pickup type tasks and merging</li>
                <li>Tasks now have a pending approval status. Despatch based tasks assigned to pre-paid / COD orders that are not fully paid will require the task to be approved before continuing</li>
                <li>Task Account permission added, required for approving tasks in pending approval status</li>
              </ul>
              <strong>Inventory</strong>
              <ul>
                <li>The delivery type fee option in stock items has been removed. This is now linked directly in task types via the Task Configuration area</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Fixed issue where some arcs for center cutouts were being inverted in waterjet DXF exports</li>
                <li>Scanned sheet allocations on optimiser sheets can now be reverted at optimiser station</li>
                <li>Added support to split offcuts on a sheet at the optimiser station</li>
              </ul>
              <strong>Contacts</strong>
              <ul>
                <li>Contacts now have a drop down for preferred despatch type that links to the task type</li>
                <li>Default despatch service fees are now setup for contacts for each task type instead of just the default despatch fee</li>
                <li>Contact addresses now have despatch fees for each task type. If set, this overrides the contact service fees for orders linked to the address</li>
                <li>A proper onsite label has been added to Address Despatch Tag for contact addresses. This will be used for orders with a custom address</li>
              </ul>
              <strong>Automations</strong>
              <ul>
                <li>Added automation action component to get a list of all active orders that are overdue</li>
              </ul>
              <strong>App</strong>
              <ul>
                <li>App updated to match the update to order despatch types</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.8.4</ContentTitle>
              <ContentSubTitle>23/02/2025</ContentSubTitle>
              <strong>Production</strong>
              <ul>
                <li>Added max cutting depth to optimiser cutting hardware settings</li>
                <li>Added offcut overflow setting to optimiser cutting hardware settings</li>
                <li>Updates to sheet trim in exports for optimiser based on origin position</li>
                <li>Printing optimiser sheet labels now has a dialog with the ability to reprint panel or offcut labels</li>
                <li>Fixed up group counts for optimiser sheet schedule</li>
                <li>Fixed up group counts for production panel schedule</li>
                <li>Orders with split sheets will now go on hold correctly if no stock sheets exist. For systems with optimisation enabled</li>
              </ul>
              <strong>Optimiser</strong>
              <ul>
                <li>New packing algorithms have been added to the optimiser that produce neater layouts where similar sized panels are available for packing</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Fixed issue with corner radiuses when extruding a segment of the panel</li>
                <li>Seperate function in cutting tool now correctly seperates panels with center cutouts</li>
              </ul>
              <strong>Analytics</strong>
              <ul>
                <li>Panel Stage Task List now has order due date column &amp; filter available</li>
              </ul>
              <strong>MYOB</strong>
              <ul>
                <li>A new integration is now available to connect Synergy with MYOB to sync Contacts and Accounts</li>
                <li>Please note this is only available for cloud based MYOB products</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.8.3</ContentTitle>
              <ContentSubTitle>06/01/2025</ContentSubTitle>
              <strong>Contacts</strong>
              <ul>
                <li>Added default tax rate to customers. Defaults to company default if not set</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Orders now uses default tax rate based on customer default tax rate</li>
              </ul>
              <strong>Analytics</strong>
              <ul>
                <li>Beginning of support for reports to be filtered by account location. Note that not all reports can be filtered by location</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Added origin position option for optimiser cutting exports in the production station. Defaults to bottom, left</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>
        </WhatsNewGroup>

        <WhatsNewGroup title="2024">
          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.8.2</ContentTitle>
              <ContentSubTitle>04/12/2024</ContentSubTitle>
              <strong>Core</strong>
              <ul>
                <li>Various performance improvements</li>
                <li>Updates to styling</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.8.1</ContentTitle>
              <ContentSubTitle>02/12/2024</ContentSubTitle>
              <strong>Inventory</strong>
              <ul>
                <li>Fixed issue with manual stock adjustment</li>
              </ul>
              <strong>Core</strong>
              <ul>
                <li>Various performance improvements</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Spring 2024 Update - v2.8.0</ContentTitle>
              <ContentSubTitle>01/12/2024</ContentSubTitle>

              <strong>Account Locations</strong>
              <p>Account locations are now more prominent throughout the system. Inventory, Orders, Production, Purchasing and Contacts all now have references to account locations. 
                By default, everything remains in the default location but can be expanded to multiple locations as required.<br />
              Account locations are accessible via the Company Account page in the admin menu.</p>
                  
              <strong>Rebrand</strong>
              <p>We have a new modern look to coincide with the launch of our new <a href="https://synsoft.com.au">website</a></p>
              
              <strong>Inventory</strong>
              <ul>
                <li>Added inventory bin system to group stock and production items into bins</li>
                <li>Inventory bin management can be found in inventory config</li>
                <li>Updates to stock levels tab in stock page to show inventory bin details</li>
                <li>General stock with tracking quantities set now has stock levels tab</li>
                <li>Stock transactions now have a "moved" direction added for stock moved between inventory bins</li>
                <li>Stock transactions now have source and destination inventory bins</li>
                <li>Stock transactions now have grain direction for offcuts of stock with a grain</li>
                <li>Receiving stock / panels in purchase orders will go to the inventory bin flagged with default received</li>
                <li>Manual reason removed from manual stock adjustments. Only notes field required now</li>
                <li>Added inventory bin print label type</li>
                <li>Inventory transaction list now refreshes automatically when stock transactions occur</li>
                <li>Added stock movement permission type to allow stock movement transactions in the app</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Added location setting for production stations</li>
                <li>Added location setting for optimiser sheets</li>
                <li>Added transfer lead time setting in production config to add to production scheduling if transfers between locations are required</li>
                <li>Added location display info to multi-location based panels in production view app</li>
                <li>Added bin selection when cutting sheets and sheets are in multiple inventory bins</li>
                <li>Panels now automatically route between account locations based on station availability. This is based on quickest path</li>
                <li>All production station views now have scan options button to control the inventory bins panels go to when scanning out</li>
                <li>Added production manager permission. Allows access to production manager dashboard &amp; station overrides</li>
                <li>Production administrator permission has been deprecated and replaced by production manager permission</li>
                <li>Added maintenance mode to production stations to flag stations as unavailable during downtime or periods of maintenance</li>
                <li>Added station override display on production panel page</li>
                <li>Added production manager page to display production overview and control routing of production items</li>
                <li>Panels with external stages will now automatically have transfers setup to support transfer to / from suppliers</li>
                <li>Added completed stats to station app status graph</li>
                <li>Added NCR repair notes to panel print label </li>
                <li>Schedule lists for stations are now hiding orders on hold by default</li>
                <li>Fixed up panel &amp; order group counts for production station schedule lists</li>
                <li>Fixed issue with colour code placement for large text codes on print labels. Eg, 'URGENT'</li>
              </ul>
              <strong>Optimiser</strong>
              <ul>
                <li>Added more activity log entries for optimiser sheets processing at optimiser stations</li>
              </ul>
              <strong>Contacts</strong>
              <ul>
                <li>Added default location setting for contacts</li>
                <li>Minor updates to new contact page</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Added location setting for orders</li>
                <li>Transfer info display added to order production preview display for production items that require transferring during production</li>
              </ul>
              <strong>Tasks</strong><br />
              The entire task system has had a rebuild with the following features:
              <ul>
                <li>More flexible support for how items are linked to the tasks</li>
                <li>Added internal transfers task item type to move panels / stock between account locations</li>
                <li>Added external transfers task item type to move panels / stock to/from external suppliers</li>
                <li>Option to task type to require a primary user to be set on task creation</li>
                <li>Task routes are now displayed with primary user colour</li>
                <li>Fixed non-trackable stock items (eg, minimum invoice) being included in pickup task generated from kiosk</li>
                <li>COD Orders that have been fully paid (but still partially in production) can now be scanned into tasks</li>
                <li>Orders without despatchable items (eg, just a fee) can now be included in a task with other despatchable items</li>
                <li>Adding manual stock via the app now requires an inventory bin selected</li>
                <li>Cancelling tasks / task items now requires a reason &amp; labels</li>
                <li>Purchase orders can now be selected in the task new dialog for transfers / pickups</li>
                <li>Support for taking multiple photos for general tasks. Photos are attached to the task.</li>
              </ul>
              <strong>Purchase Orders</strong>
              <ul>
                <li>Added location setting for purchase orders. Inventory items will be moved to this account location on completion.</li>
                <li>Added supplier address to purchase orders. Used for pickups</li>
                <li>Improved support of pickup vs delivery of purchase orders</li>
                <li>Added pending pickup status to purchase orders for standard/external purchase orders with pickup despatch type</li>
                <li>Added support for tasks assigned flag on purchase orders</li>
                <li>Added display of tasks associated with purchase orders</li>
              </ul>
              <strong>Analytics</strong>
              <ul>
                <li>Fixed issue with NCR report for template order items</li>
                <li>Added Sales Rate column to customer pricing report</li>
              </ul>
              <strong>Core</strong>
              <ul>
                <li>Account locations now have active setting and locations cannot be removed</li>
                <li>Account locations now have pickup label available to specify pickup availability</li>
                <li>Account permission now has 'create' access added to for creation of account locations</li>
                <li>Print label config now has a barcode option to select between 1D and 2D (QR) barcode types</li>
                <li>General system performance improvements</li>
              </ul>
              <strong>App</strong><br />
              <ul>
                <li>Updated the app to support the rebuilt task system</li>
                <li>Inventory bins can be selected / scanned when entering in manual stock</li>
                <li>Cleanup of the sign off page</li>
                <li>Support for taking photos to attach to a task</li>
                <li>Added account location setting for the kiosk screens to use</li>
                <li>Kiosk mode auto refreshes to avoid being logged out over time</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.7.8</ContentTitle>
              <ContentSubTitle>22/11/2024</ContentSubTitle>
              <strong>Core</strong>
              <ul>
                <li>Various performance improvements</li>
              </ul>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.7.7</ContentTitle>
              <ContentSubTitle>13/11/2024</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Minor fixes to production charts on production dashboard</li>
                <li>Various column charts now have csv export option</li>
                <li>Various column charts now have fullscreen option</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Added scanning warnings on the station if a station cannot support a scanned in panel (via station capabilities)</li>
                <li>Added station scan warning override dialog</li>
                <li>Fixed up lead in/out starting position for center cutouts that have large corner radiuses</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Corner radiuses on shape vertices now have precision of 1 decimal place (was rounded to nearest whole number)</li>
                <li>Corner radiuses on edge/corner cutouts now have precision of 1 decimal place (was rounded to nearest whole number)</li>
              </ul>
              <strong>Core</strong>
              <ul>
                <li>Various performance improvements</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.7.6</ContentTitle>
              <ContentSubTitle>03/11/2024</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Added month breakdown for order value summary report</li>
                <li>Added total completed panel count to production stage chart</li>
                <li>Added production stage monthly completed units chart to production dashboard</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Added more info to orders preview popup on order lists</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Added units selection for DXF import dialog in the editor</li>
              </ul>
              <strong>Core</strong>
              <ul>
                <li>Improved the document file list used in the system</li>
                <li>Improved the document preview dialog</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.7.5</ContentTitle>
              <ContentSubTitle>15/10/2024</ContentSubTitle>
              <strong>Orders</strong>
              <ul>
                <li>Scan orders dialog (via main orders list) now can complete production seperately (without despatching orders)</li>
                <li>Force completing an order via admin will now run checks on any associated tasks in pending production status</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Waterjet now logs DXF exports to the panel activity log, with DXF attached</li>
                <li>Added documents tab to production panel page</li>
              </ul>
              <strong>Core</strong>
              <ul>
                <li>Improvements to how some file attachments options in the system are linked to activity logs</li>
                <li>Improvements to DXF file attachment previews</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.7.4</ContentTitle>
              <ContentSubTitle>14/10/2024</ContentSubTitle>
              <strong>Order Editor</strong>
              <ul>
                <li>Added a link to the DXF Import guidelines PDF document on the DXF import dialog. This can be sent to customers who provide DXF files for their orders</li>
              </ul>
              <strong>Xero</strong>
              <ul>
                <li>Fixed issue with invoices showing xero sync errors after marked as paid. Still correctly sync with Xero</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Fixed issue with copying orders containing templated items (eg, IGUs)</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.7.3</ContentTitle>
              <ContentSubTitle>13/10/2024</ContentSubTitle>
              <strong>Accounts</strong>
              <ul>
                <li>Added account administrator user permission</li>
                <li>Users with account administrator permission can edit an invoice due date</li>
                <li>Users with account administrator permission can close an unpaid invoice and flag it as paid with zero amount due</li>
                <li>Users with account administrator permission can close an overpayment and flag it as allocated with zero amount available</li>
                <li>Users with account administrator permission can close a credit note and flag it as credited with zero credit available</li>
              </ul>
              <strong>Contacts</strong>
              <ul>
                <li>Editing contact credit details now shows up in activity log</li>
                <li>Contacts credit status now has a field for minimum monthly spend</li>
                <li>Contacts credit status now has a field for minimum spend administration fee</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Fixed rare issue where large complex panels with stepped edges would have incorrect cutting lines (for optimiser)</li>
                <li>Fixed rare issue where some complex panels would have cutting lines extended out past the actual panel size</li>
                <li>Fixed issue where edgework on long side of detailed complex shapes would be flagged as short in description</li>
                <li>Fixed issue with using cutting tool to split arcs results in small errors in the shape which lead to incorrect cutouts detected</li>
                <li>Fixed issue with side/corner cutouts beginning along an arc and not including the arc within the cutout</li>
              </ul>
              <strong>Inventory</strong>
              <ul>
                <li>Added grain column to stock levels for stock with grain</li>
              </ul>
              <strong>Optimiser</strong>
              <ul>
                <li>Creating custom sized sheets for stock with grain direction now must select a grain direction</li>
                <li>Added rotated, custom and offcut labels to sheet info in the optimiser editor</li>
                <li>Fixed issues with changing optimiser sheets between different stock levels / offcuts / custom size with grain directions</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Improved display of dimensions in order item preview for tall and skinny panels</li>
                <li>Setting a requested date that is on a non-business day, during a closure or on a public holiday will now flag a production approval</li>
                <li>Fixed issue with automations running twice after unholding an order that also changed status</li>
                <li>Updates to order info button popover</li>
                <li>Fixed NCR creation for templated order items (eg, IGU)</li>
                <li>Fixed order items for glass not tracking quantities (eg, customers own glass) showing insufficient stock errors</li>
                <li>Added despatch type filter to order list</li>
                <li>Added additional production checks after editing order in pending COD status</li>
                <li>Order items with panels currently in despatch can now have quantity reduced when edited by users with order administrator permission</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Optimiser sheets using stock that is flagged as hand cut can now be exported at optimiser cutting station</li>
                <li>Cuts in optimiser exports that are not connected are now extended to the edges</li>
                <li>Fixed 'Requires Order Printer' checkbox in new production stage dialog</li>
                <li>Manually cutting an offcut now detects if it's already cut</li>
                <li>Reverting a manually cut offcut will now restore the original offcut barcode instead of creating a new one</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Fixed stoppage event detection start date for location based task types</li>
              </ul>
              <strong>Purchasing</strong>
              <ul>
                <li>Purchase orders in receiving status now cannot have purchase order items edited directly. Edit the receiving list to modify</li>
                <li>Added tool to add multiple items to receiving bulk items</li>
              </ul>
              <strong>Analytics</strong>
              <ul>
                <li>Minimum monthly spend widget added to contact dashboard in analytics</li>
                <li>Fixed sales summary report CSV export</li>
                <li>Added order detailed sales summary report for services</li>
              </ul>
              <strong>Core</strong>
              <ul>
                <li>Email addresses ending with a dot are now flagged as invalid in email input boxes as they are invalid with our email provider</li>
                <li>Fixed rounding display of some values in analytics</li>
                <li>Improved google map loading performance</li>
                <li>Address search added to account location dialog</li>
                <li>Adding/Removing documents for various objects now gets logged in the activity log of that object</li>
                <li>Fixed errors when searching a list with certain characters in the search box</li>
              </ul>
              <strong>Xero</strong>
              <ul>
                <li>Updated Xero integration link on various item (contact, invoice, payment, etc) pages to show if a sync error occurred</li>
              </ul>
              <strong>App</strong>
              <ul>
                <li>Fixed partial scan in popup not showing up if task is in pending production state</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.7.2</ContentTitle>
              <ContentSubTitle>04/06/2024</ContentSubTitle>
              <strong>Tasks</strong>
              <ul>
                <li>Fixed up task progress display for location based tasks</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.7.1</ContentTitle>
              <ContentSubTitle>03/06/2024</ContentSubTitle>
              <strong>Tasks</strong>
              <ul>
                <li>Fixed issue with panel completing production not updating tasks pending production</li>
                <li>Fixed issue with merging orders to existing tasks</li>
                <li>Fixed display of user popover on the task map</li>
                <li>Fixed issue with loading offcuts</li>
              </ul>
              <strong>App</strong>
              <ul>
                <li>Added a button to view order details when scanning a panel in the scan page</li>
                <li>Added ability to view the order when scanning in a panel not associated with a task</li>
                <li>Added ability to include the entire order when scanning a panel not associated with a task</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Major Update - v2.7.0</ContentTitle>
              <ContentSubTitle>02/06/2024</ContentSubTitle>
              <strong>Tasks</strong>
              <ul>
                <li>Major refactor of the task system. Task Types (in task configuration) now control rules and flow of task system</li>
                <li>Various task despatch settings have been moved to individual task type configuration</li>
                <li>Kiosk task settings have been moved to individual task type configuration</li>
                <li>Stoppage task item type added</li>
                <li>Task Item stoppage label type added to system</li>
                <li>User despatch labels have been removed. Task types now have default users that are assigned to tasks by default</li>
                <li>Task Type condition automation component added to get task type. Task type field is not longer available in the Task Condition component</li>
                <li>Lead time removed from resource groups. Now set via task types</li>
                <li>Order despatch no longer linked to resource groups for lead time calculations</li>
                <li>Task Types now control lead time for orders based on despatch type</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Added order summary popover to main order list</li>
                <li>Standard hold type removed. A specific hold type will now need to be selected</li>
                <li>Fixed issue with draft orders showing an incorrect estimated date before they move into production</li>
                <li>Added notice icon for estimated due date for orders in draft mode</li>
                <li>
                  Added the ability to force an update of order items if an item is already cut and layout/stock changes have been made.<br />
                  Only available for users with order administrator permission
                </li>
                <li>Added automation component to get a list of orders on hold for X number of days</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Improved memory / performance of the order editor to help reduce stability issues</li>
                <li>Can now use editing tools on circle and oval shapes</li>
                <li>Can now add edge / corner cutouts to circle and oval shapes</li>
                <li>Center cutouts can now be offset from start or end of datum lines, measured along the datum line</li>
                <li>Fixed up edgework flags so all round is not displayed for large arcs with edgework</li>
              </ul>
              <strong>Optimiser</strong>
              <ul>
                <li>Fixed issue with flagged v-cuts lost when moving panels to scratch area in optimiser editor</li>
              </ul>
              <strong>Purchasing</strong>
              <ul>
                <li>Added preview popover on purchase order list to show purchase order items</li>
                <li>Fixed standard purchase orders importing glass with stock linked price groups and not adding stock if it has processed items (eg, cutting charges)</li>
                <li>Additional costs in purchase order receiving tab now allows minus values (used for corrections)</li>
              </ul>
              <strong>Analytics</strong>
              <ul>
                <li>Fixed issue with days ahead/behind calculation for production stages</li>
                <li>Fixed export of contact person list not exporting last name column</li>
                <li>Added order summary report based on grouped data</li>
                <li>Added inventory summary report based on grouped data</li>
                <li>Added stock value breakdown in summary for sheets and blocks vs offcuts</li>
              </ul>
              <strong>Accounts</strong>
              <ul>
                <li>Credit notes now require an order to be linked to</li>
                <li>Added order link on credit note page</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Production config now seperated from task config</li>
                <li>Fixed issue with floating stages so they now cannot scan in if the panel is still in production at another station</li>
              </ul>
              <strong>Inventory</strong>
              <ul>
                <li>Task Completable option added to general stock in inventory. If set, these items can be selected by the task system to be completed / invoiced for task run sheets</li>
                <li>Double sided glass now has a new cutting side up setting for optimiser to use as the default side up when cutting</li>
                <li>Order editor now uses the default side up setting in inventory for double sided glass for new shapes</li>
              </ul>
              <strong>Users</strong>
              <ul>
                <li>Owner user can disable the MFA setting for other users. Used in cases where users lose access to their device</li>
              </ul>
              <strong>Core</strong>
              <ul>
                <li>Removed unused lookup types from general config</li>
                <li>Added address to lookup types in general config. Used by task system for associating names to common addresses</li>
              </ul>
              <strong>App</strong>
              <ul>
                <li>The Synergy app for iOS / Android has been updated and requires an update on all devices for the new task system</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.6.2</ContentTitle>
              <ContentSubTitle>04/04/2024</ContentSubTitle>
              <strong>Tasks</strong>
              <ul>
                <li>Improved task item markers on delivery maps</li>
                <li>Users hidden from task maps after 2 hours since last location update (was 12hrs)</li>
                <li>Added detection of users departing start location after starting delivery</li>
                <li>Added detection of users arriving at end location after completing delivery</li>
                <li>Task system performance updates</li>
                <li>Added start/end task route location markers on the map</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.6.1</ContentTitle>
              <ContentSubTitle>02/04/2024</ContentSubTitle>
              <strong>Tasks</strong>
              <ul>
                <li>Fixed issue with updating task</li>
                <li>Improved task item markers on delivery maps</li>
                <li>Fixed leave detection on task items</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Fixed issue with order duration report</li>
                <li>Order reports now ignore draft orders</li>
                <li>Added &apos;Order Contains Recut&apos; flag to order condition automation component</li>
                <!-- <li>Added previous status field to order condition automation component</li> -->
              </ul>
              <strong>Analytics</strong>
              <ul>
                <li>Updates to production capacity daily chart</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Major Update - v2.6.0</ContentTitle>
              <ContentSubTitle>01/04/2024</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Added production station capacity widget</li>
                <li>Added production station capacity daily chart</li>
                <li>Added order duration daily chart</li>
                <li>Fixed issue with days behind/ahead calculation for production analytics</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Added address searching to order edit despatch dialog</li>
                <li>Updated cancel order dialog handling of additional cancellation fees</li>
                <li>Updated cancel order item dialog to support charging stock/production/additional fees</li>
                <li>Added precision of 1 decimal place in radius/width/height when creating new shapes in order editor</li>
                <li>Fixed ruler display in order editor when browser is not at 100% zoom level</li>
                <li>Added phone number for order contact person to main summary display</li>
                <li>Added line overlap detection in order editor DXF import</li>
              </ul>
              <strong>Core</strong>
              <ul>
                <li>Fixed availability shift editing in config area</li>
                <li>Fixed date range filters so the start/end dates are set to the start/end of the respective days. Fixes issues with incorrect reporting data for manually entered dates</li>
                <li>Added global label type list in general config</li>
                <li>Settings from system settings page now moved to all module specific config pages</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Tracking of users routes for deliveries is now only done for the user that started the delivery</li>
                <li>Updates to display/editing of delivery/pickup tasks on main task page</li>
                <li>Added detection of drivers leaving task item locations after completion</li>
                <li>Added more details to task item popover for the task map</li>
                <li>Added popover for task item clicked on the main task preview area</li>
                <li>Added stoppage route event for delivery tasks</li>
                <li>Added signal loss route event for delivery tasks</li>
                <li>Added route events automation components</li>
                <li>Completing loading of delivery tasks now moves status into active</li>
                <li>Updates to linked order items for active delivery/pickup tasks now moves it back to loading status if required</li>
                <li>Notifications sent out for tasks that have updates to linked order items (ie, merged tasks)</li>
                <li>Fixed issue with scanning in panels/blocks linked to other tasks that had cancelled task items</li>
                <li>Order items linked to a task item are no longer removed after the task/task item is cancelled/completed</li>
                <li>Orders linked to tasks now have more activity log entries when task is linked / unlinked to the order</li>
                <li>Fixed issue with merging in template order items into existing pickup tasks</li>
                <li>Fixed issue with scanning in panels into a task with cancelled &amp; re-added task items for the same panel</li>
                <li>Added display for partial scanning in of deliveries</li>
              </ul>
              <strong>Purchasing</strong>
              <ul>
                <li>Added a range of automation components for purchase orders</li>
              </ul>
              <strong>Automations</strong>
              <ul>
                <li>All email action components have had a CC field added. Note that this field does not support placeholders</li>
              </ul>
              <strong>Users</strong>
              <ul>
                <li>Added user condition automation component</li>
              </ul>
              <strong>Xero</strong>
              <ul>
                <li>Added Xero error notification to automations when attempting to import batch payments linked to invoices with different contacts</li>
              </ul>
              <strong>App</strong>
              <ul>
                <li>Improved GPS tracking on the app during deliveries</li>
                <li>Added tracking of delivery drivers for 90mins after delivery completion</li>
                <li>Added checking of late arrival &amp; requesting late arrival details on signoff</li>
                <li>Added manual barcode entry for stocktake</li>
                <li>Added barcode scanner tester under More</li>
                <li>Added scan page to scan any barcode</li>
                <li>Added input details for partial scanning in when starting a delivery</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.5.2</ContentTitle>
              <ContentSubTitle>03/03/2024</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Fixed order breakdown widget</li>
                <li>Fixed performance on production widgets</li>
                <li>Fixed rounding on accounts summary widget</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Fixed performance on station chart</li>
                <li>Updated coated side info on toughened print labels</li>
                <li>Updated toughened prefix on toughened print labels</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Added address searching to new external purchase orders for orders</li>
                <li>Added confirmation message box when exiting the order page while editing order items</li>
                <li>Fixed minor errors in order stamp config dialog</li>
              </ul>
              <strong>Purchasing</strong>
              <ul>
                <li>Added address searching to editing purchase order delivery address</li>
                <li>Added address searching to new purchase order delivery address</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Added address searching to edit task item &amp; new delivery task start/end addresses</li>
              </ul>
              <strong>Core</strong>
              <ul>
                <li>Search feature in lists now supports quotes around words to search as-is</li>
              </ul>
              <strong>Xero</strong>
              <ul>
                <li>Added sync message to activity log when syncing credit note allocations</li>
                <li>Updated credit note syncing to xero to avoid re-syncing credit notes and causing sync warnings</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.5.1</ContentTitle>
              <ContentSubTitle>28/02/2024</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Added toughening bed yield chart to production dashboard</li>
                <li>Added date range filters to daily/monthly invoice charts</li>
                <li>Fixed inventory monthly stock value chart to display correct data</li>
                <li>Updates to glass stock value report</li>
                <li>Cleanup for charts getting cut off</li>
                <li>Added stock usage columns to the stock reorder report</li>
                <li>Purchasing incoming stock list moved to purchasing dashboard</li>
                <li>Added summary widget to top of accounts dashboard</li>
                <li>Added daily/monthly charts for payments received in accounts dashboard</li>
                <li>Added summary widget to top of orders dashboard</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Updated performance chart on production station to simpler style</li>
                <li>Added yield display for toughening loading bed</li>
                <li>Split up mean thickness for patterned toughening batches into 2 groups</li>
                <li>Fixed bug with production panel list not working in admin area</li>
              </ul>
              <strong>Contacts</strong>
              <ul>
                <li>Added send accounts statement option from the contact details page</li>
              </ul>
              <strong>Xero</strong>
              <ul>
                <li>Added date to sync error list (if applicable)</li>
                <li>Added ability to clear some sync error messages</li>
              </ul>
              <strong>Core</strong>
              <ul>
                <li>Added address autocomplete feature for orders and contact address inputs</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Major Update - v2.5.0</ContentTitle>
              <ContentSubTitle>18/02/2024</ContentSubTitle>
              <strong>Analytics</strong>
              <ul>
                <li>Major dashboard updates</li>
                <li>Old intelligence widgets removed from home screen</li>
              </ul>
              <strong>Pricing</strong>
              <ul>
                <li>General updates to price request system</li>
                <li>Price updates now go into generating price list status while processing pricelists after completing draft price updates</li>
                <li>Pricelist snapshots now generated for price requests that do not automatically generate price lists to show archived changes in pricelists for customers</li>
                <li>Sales prices now cannot be updated while another sales price update is processing</li>
                <li>Archived price list on contact page now sorted correctly</li>
              </ul>            
              <strong>Purchase Orders</strong>
              <ul>
                <li>Added more activity log items on stock receival completed</li>
                <li>Added more activity log items on external PO completed for panels</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Added delivery instructions field for orders with delivery despatch type</li>
                <li>Orders requested after the estimated due date will now use Just-In-Time scheduling, so the first stage of production will be deferred</li>
                <li>Fixed issue where changing despatch type on an order already in production did not update estimated / due dates</li>
                <li>Added a seperate cancel order item permission</li>
                <li>Updated so the user cannot cancel the last order item in an order unless they have cancel order permission</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Added extra field for task item details to be displayed on run sheet</li>
                <li>Task item details automatically filled in by order delivery instructions for delivery tasks</li>
                <li>Fixed issue with 'Tasks Assigned' flag on orders not resetting if no items from a linked order are despatched</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Updates to toughening batch for the toughening stations. Now supports more compliance details, better flow and print label updates</li>
                <li>Added furnace loading bed size config to production station hardware details. Used for furnace bed yield reporting</li>
              </ul>
              <strong>Inventory</strong>
              <ul>
                <li>Added filter options for inventory transaction type</li>
                <li>Changed status label for glass blocks</li>
                <li>Added print offcut label action to the glass offcut list</li>
                <li>Added print block label action to the glass block list</li>
                <li>Added sales order column &amp; filter to the glass block list</li>
                <li>Fixed UI bug where an error would pop up when progressing through stocktake status types</li>
                <li>Changed two sided glass to have pattern / coated options. Used for toughening batch details</li>
              </ul>
              <strong>Automations</strong>
              <ul>
                <li>Conditions now support placeholders in text field values</li>
                <li>Added general comparison condition component for comparing two values / placeholders</li>
              </ul>
              <strong>General</strong>
              <ul>
                <li>Fixed up manual entry on date input fields</li>
                <li>Added outgoing email reply-to field for users to override account default reply-to field</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>
        </WhatsNewGroup>

        <WhatsNewGroup title="2023">
          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.4.2</ContentTitle>
              <ContentSubTitle>18/12/2023</ContentSubTitle>
              <strong>Orders</strong>
              <ul>
                <li>Orders completed will now clear hold flag</li>
                <li>Glass stock sheet selection for orders now matches inventory stock level list</li>
                <li>Performance updates for order list</li>
                <li>Increased workspace area size and zoom out max distance in glass editor</li>
              </ul>
              <strong>Purchase Orders</strong>
              <ul>
                <li>Added weight details for purchase order glass items</li>
              </ul>
              <strong>Optimiser</strong>
              <ul>
                <li>Fixed issue with duplicate panels across multiple optimiser sheets</li>
                <li>Optimiser will now respond to panels cancelled while cutting sheet and close the sheet if the last panel has been cancelled</li>
              </ul>
              <strong>Inventory</strong>
              <ul>
                <li>Option to show/hide glass levels with zero values in stock page. Defaulted to hidden</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Order list will show prepaid/cod orders as paid if invoiced prior to completion and invoice is paid when creating new delivery/pickup tasks</li>
                <li>Added <code>TaskItem.OnRouteArrival</code> placeholder for automations referencing TaskItems for on-route estimated arrival times. Generates a smaller 15 min window, rounded to 5 minute intervals</li>
                <li>Cancelled / Recut panels will clear scanned in/out quantities for any active despatch tasks</li>
              </ul>
              <strong>Analytics</strong>
              <ul>
                <li>Contact analytics dashboard now available</li>
                <li>Performance updates for order analytics</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.4.1</ContentTitle>
              <ContentSubTitle>04/12/2023</ContentSubTitle>
              <strong>Core</strong>
              <ul>
                <li>Yesterday option added to date select&apos;s</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Pre-paid/COD orders moved from pickup to delivery with a new delivery fee will now be placed on accounts hold</li>
                <li>Added more activity logs for despatch type changes</li>
              </ul>
              <strong>Analytics</strong>
              <ul>
                <li>Fixed issues with performance of new dashboard</li>
                <li>Enabled new analytics dashboard</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Major Update - v2.4.0</ContentTitle>
              <ContentSubTitle>01/12/2023</ContentSubTitle>
              <strong>Core</strong>
              <ul>
                <li>New calendar system for shifts, closures and public holiday settings</li>
                <li>Production / Task Shifts removed and moved to calendar configuration</li>
                <li>Additional options added to date range filters</li>
                <li>Added more filtering/searching options to all activity logs</li>
                <li>Updated date range filter for data tables</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Added scheduled start date display for assigned despatch tasks pending start</li>
                <li>Added mobile/email display on order page for non-custom contact people</li>
                <li>Removed old despatch docket attachment info from despatched orders</li>
                <li>Invoiced filter on order list ignores completed orders</li>
                <li>Total Units displayed on the order PDF report is now shown to full 5 decimal places</li>
              </ul>
              <strong>Inventory</strong>
              <ul>
                <li>Added glass offcut list</li>
                <li>Added ability to manually adjust glass size moving average price</li>
              </ul>
              <strong>Accounts</strong>
              <ul>
                <li>Total Units displayed on the invoice PDF report is now shown to full 5 decimal places</li>
              </ul>
              <strong>Analytics</strong>
              <ul>
                <li>Renamed intelligence module to analytics</li>
                <li>All new analytics dashboard</li>
                <li>All report filter popovers have been updated with new date range system and apply/reset settings</li>
                <li>Added contact filter to detailed order sales summary</li>
              </ul>
              <strong>Automations</strong>
              <ul>
                <li>Fixed description of condition components using boolean types</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Major Update - v2.3.0</ContentTitle>
              <ContentSubTitle>14/11/2023</ContentSubTitle>
              <strong>Inventory</strong>
              <ul>
                <li>Added hand cut, grain and two sided labels in stock list</li>
                <li>Added sheet trim top to stock production override settings</li>
                <li>Added ability to print offcut labels from stock levels page in inventory</li>
              </ul>
              <strong>Optimiser</strong>
              <ul>
                <li>Combined multiple cutting lines along same axis in optimiser exporting</li>
                <li>Improved optimiser support for optimiser sheets &amp; orders with large number of small panels</li>
                <li>Cleanup of text labels for very small/skinny panels in the editor</li>
                <li>Fixes for orders going on stock hold when stock available</li>
                <li>Re-running a stock optimisation process via production station app will release stock hold on associated orders for re-checking</li>
                <li>Improved cutting export tooling used for lines and arcs for better cutting paths</li>
                <li>Added additional checks for duplicate panels when moving optimiser sheets into cutting</li>
                <li>Lots of general improvements to panel layout and rules in optimiser sheets</li>
                <li>Support for offcut layout settings per optimiser station</li>
                <li>Fixed issue with editing rotated custom sized sheets</li>
                <li>Fixed issue with exporting sheets that contain panels with size overidden</li>
                <li>Added support for blank panels in optimiser sheet editor</li>
              </ul>
              <strong>Pricing</strong>
              <ul>
                <li>Sales price updates now by default do not auto-generate customer price lists. This can be edited per price update request if required.</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Fixed issue with NCR orders not being able to update items via the editor during NCR creation</li>
                <li>Force order invoiced now uses order accounts approval permission</li>
                <li>Invoiced label added to order table filter options</li>
                <li>Force order invoiced automation component now forces invoice only (was despatch too)</li>
                <li>Added automation component to get list of orders awaiting despatch for X days</li>
                <li>Fixed issue with stock level calculations for order items linked to stock</li>
                <li>Added display of additional info when new order screen has errors calculating estimates due to invalid order items</li>
                <li>Added support for payment advice on order sheet PDF</li>
                <li>Added production required setting for order condition automation component</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Added task cancel permission for cancelling tasks or task items. Task app permission can still cancel task items</li>
                <li>Added pickup loading notes to task boxes on orders</li>
              </ul>
              <strong>Accounts</strong>
              <ul>
                <li>Zero value invoices are now automatically flagged as paid on creation</li>
                <li>Added support for payment advice on invoice sheet PDF</li>
              </ul>
              <strong>Contacts</strong>
              <ul>
                <li>Added label filter options to contacts list</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Added order hold details for panel popover in production station app</li>
                <li>Can now start cutting panel batches if panels are on stock hold</li>
              </ul>
              <strong>Core</strong>
              <ul>
                <li>Added payment advice settings in report configuration area</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.2.1</ContentTitle>
              <ContentSubTitle>18/10/2023</ContentSubTitle>
              <strong>Orders</strong>
              <ul>
                <li>Order despatch and invoicing have been seperated</li>
                <li>Added ability to force an order to be invoiced before despatching</li>
                <li>Added invoiced status to order table for orders invoiced before completion</li>
                <li>Fixed cancelled order items copying to new order as cancelled</li>
                <li>Added invoice outstanding/amount values to invoice boxes on an order</li>
                <li>Fixed issue with split line dimensions in order editor not rounding to nearest mm</li>
                <li>Disabled editing of invoiced/despatched items in editor</li>
                <li>Disabled the apply actions for cancelled/invoiced/despatched items in the order item list</li>
                <li>Fixed issue with large images not uploading to order stamp config</li>
              </ul>
              <strong>Contacts</strong>
              <ul>
                <li>Added send contact email component to automations</li>
                <li>Editing of customer price rate details moved to customer pricing tab</li>
                <li>Fixes to price lists emailed during price request approval</li>
              </ul>
              <strong>Core</strong>
              <ul>
                <li>Updated style of payments/task/invoice display boxes</li>
                <li>Fixed unicode support for stock transaction text</li>
                <li>Added state code editing to account dialog</li>
                <li>Added file type restrictions for uploads</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Updated route start/end options for delivery tasks</li>
                <li>Added reloading of existing delivery tasks when creating new delivery task</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Support for skipping arc for waterjet cutouts for lead in/out if below minimum size</li>
                <li>Fixes for lead in/out on waterjet cutouts</li>
                <li>Fixed waterjet path direction for some cutouts</li>
                <li>Added generic waterjet hardware type for exporting</li>
                <li>Added Optima compatible cutting station type</li>
                <li>Added option to print individual panel labels for panels in a cutting batch</li>
                <li>Cleaned up wrapped text on production app search results</li>
                <li>Added expand/collapse buttons to production app search results</li>
                <li>Added stock name to panel popover in production app</li>
              </ul>
              <strong>Xero</strong>
              <ul>
                <li>Added checks for importing transactions reconciled directly to invoices</li>
                <li>Added support for syncing cancelled overpayments to Xero</li>
                <li>Added support for syncing cancelled credit notes to Xero</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Major Update - v2.2.0</ContentTitle>
              <ContentSubTitle>27/09/2023</ContentSubTitle>
              <strong>Automations</strong>
              <ul>
                <li>Complete automation module refactor</li>
                <li>All new automation components available for automation rules</li>
                <li>More components will be added over future updates</li>
                <li>The following existing automated processes have been moved to automation rules:
                  <ul>
                    <li>Send invoice email on invoice creation</li>
                    <li>Notify users when order goes on accounts hold</li>
                  </ul>
                </li>
                <li>Example automation rules have been created and disabled by default. Please edit &amp; enable rules as required by your business</li>
              </ul>
              <strong>Core</strong>
              <ul>
                <li>Fixes for using emojis in tasks / order communication log</li>
                <li>Added pagination to improve performance on all activity logs</li>
                <li>Support for SMS credits have been added to billing for future use with SMS features (coming soon)</li>
                <li>Added email validation warnings to email fields for order / contact people</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Fixes for cutting a sheet in optimiser with incorrect export settings</li>
                <li>Fixes for sheets with grain direction</li>
                <li>Production Panel labels can no longer be printed via station until they&apos;ve been printed via cutting / orders screen</li>
              </ul>
              <strong>Order</strong>
              <ul>
                <li>Fixed very long order item descriptions pushing pdf content off the page</li>
                <li>Fixed issue with external purchase orders reverting completed panels back to despatch</li>
                <li>Added mobile to orders with custom contact details</li>
              </ul>
              <strong>Contacts</strong>
              <ul>
                <li>Activity log moved to seperate tab</li>
              </ul>
              <strong>Pricing</strong>
              <ul>
                <li>Improvements to performance during price updates</li>
                <li>Improvements to performance for customer price list creation</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Added fixes to avoid duplicate order items in tasks</li>
                <li>Added fixes to avoid duplicate scanned items in tasks</li>
                <li>Fixes for GPS tracking for deliveries</li>
                <li>Stored route taken by users during deliveries &amp; displayed on task map</li>
                <li>Added more info to map task item popovers</li>
              </ul>

              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.1.18</ContentTitle>
              <ContentSubTitle>2/08/2023</ContentSubTitle>
              <strong>Tasks</strong>
              <ul>
                <li>Added default delivery users for new delivery tasks</li>
              </ul>
              <strong>Users</strong>
              <ul>
                <li>Added delivery system label for users</li>
              </ul>
              <strong>Accounts</strong>
              <ul>
                <li>Added support for cancelling payment receiveds</li>
                <li>Added support for cancelling credit notes</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Orders that have been partially invoiced / despatched can now have non-dispatched items edited</li>
              </ul>
              <strong>Automation</strong>
              <ul>
                <li>Added email bounced automation event</li>
                <li>Added notify users automation action</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Optimiser sheets now store export data. Accessed via optimiser sheet page in frontend</li>
              </ul>
              <strong>System</strong>
              <ul>
                <li>Updated notification system &amp; inbox</li>
                <li>Added handling for email bouncing (via automations)</li>
              </ul>
              <strong>Xero</strong>
              <ul>
                <li>Added display of sync messages in Xero configuration dialog</li>
                <li>Added ability to force a resync on some objects such as Contacts and Invoices</li>
                <li>Added ability to relink a Synergy contact to a different Xero contact</li>
                <li>Added ability to import a Xero Contact as a new Synergy Contact</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.1.17</ContentTitle>
              <ContentSubTitle>23/07/2023</ContentSubTitle>
              <strong>Core</strong>
              <ul>
                <li>Added pickup summary to dashboard analytics box</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Improved spacing on task customer summary report</li>
                <li>Added support for merging delivery tasks</li>
                <li>Updates to delivery mapping</li>
                <li>Fixes to task system</li>
              </ul>
              <strong>Users</strong>
              <ul>
                <li>Refactored location updates to be user based, no longer resource based</li>
                <li>Added highlight colour to users for location / task highlighting</li>
              </ul>
              <strong>Inventory</strong>
              <ul>
                <li>Added grain direction to stock offcut list</li>
                <li>Added grain direction to stock management list</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.1.16</ContentTitle>
              <ContentSubTitle>15/07/2023</ContentSubTitle>
              <strong>Core</strong>
              <ul>
                <li>Updated main dashboard to show new analytics box</li>
                <li>Added delivery summary to dashboard analytics box</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Changed name of task items for deliveries to indicate destination better</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Fixes for edgework listing on complex shapes imported in DXF</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.1.15</ContentTitle>
              <ContentSubTitle>12/07/2023</ContentSubTitle>
              <strong>Tasks</strong>
              <ul>
                <li>Added area to customer delivery sheet</li>
                <li>Updates to scanned list display for despatch tasks</li>
                <li>Added loading summary view for tasks while loading</li>
                <li>Added task expiry settings in task config</li>
                <li>General updates to delivery system</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.1.14</ContentTitle>
              <ContentSubTitle>5/07/2023</ContentSubTitle>
              <strong>Tasks</strong>
              <ul>
                <li>Updated customer delivery sheet</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Editor notes (eg, splits) added to service list on production labels</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.1.13</ContentTitle>
              <ContentSubTitle>4/07/2023</ContentSubTitle>
              <strong>Tasks</strong>
              <ul>
                <li>Updates to task system for deliveries</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.1.12</ContentTitle>
              <ContentSubTitle>2/07/2023</ContentSubTitle>
              <strong>General</strong>
              <ul>
                <li>System performance updates</li>
              </ul>
              <strong>Purchasing</strong>
              <ul>
                <li>Updated flow of purchase order receiving</li>
                <li>Can now edit purchase order received items multiple times without processing incoming stock</li>
                <li>Stock value updates now added to stock activity logs</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Updates to task system for deliveries</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.1.11</ContentTitle>
              <ContentSubTitle>25/06/2023</ContentSubTitle>
              <strong>Orders</strong>
              <ul>
                <li>Fixed calculation of edgework side descriptions for some panels (eg, Archtops)</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Updates to pickup &amp; delivery task system</li>
              </ul>
              <strong>Inventory</strong>
              <ul>
                <li>Added glass block list</li>
              </ul>
              <strong>Intelligence</strong>
              <ul>
                <li>Added square meterage to orders report</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.1.10</ContentTitle>
              <ContentSubTitle>15/06/2023</ContentSubTitle>
              <strong>Xero</strong>
              <ul>
                <li>Updated support for syncing payment allocations from Xero</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Added notes to order items in run sheet document</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Added Spline entity support for DXF importing</li>
                <li>Added block support for DXF importing</li>
                <li>Improved center cutout positions for complex DXF imports</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.1.9</ContentTitle>
              <ContentSubTitle>14/06/2023</ContentSubTitle>
              <strong>General</strong>
              <ul>
                <li>Improved performance of intelligence queries</li>
                <li>Performance improvements to the general system</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Added order payment type column to order table</li>
                <li>Fixed up detection of polylines in DXF import in editor</li>
                <li>Added despatched icon to order items</li>
              </ul>
              <strong>Intelligence</strong>
              <ul>
                <li>Fixed date ranges for order reports</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Fixed up page wrapping for delivery runsheet</li>
                <li>Added weight to delivery run sheet</li>
                <li>Minor updates</li>
              </ul>
              <strong>Accounts</strong>
              <ul>
                <li>Updated invoices to use correct title in PDF</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.1.8</ContentTitle>
              <ContentSubTitle>31/05/2023</ContentSubTitle>
              <strong>System</strong>
              <ul>
                <li>System performance updates</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Changed permission to use accounts - order entry payment permission for creating payments directly for orders</li>
                <li>Changed permission to use/skip pre-production items to order create</li>
                <li>Added button to copy an order item group</li>
                <li>Added payment type to order PDF sheets</li>
                <li>Added ability to send payment received receipt directly for order payments</li>
                <li>Updated send order/quote email dialogs to allow CC only</li>
                <li>Send order/quote email dialogs now CC custom contact email by default (if specified)</li>
              </ul>
              <strong>Intelligence</strong>
              <ul>
                <li>Split up intelligence permissions into categories</li>
              </ul>
              <strong>Purchasing</strong>
              <ul>
                <li>Added check to confirm page refresh / back button when editing purchase order receiving</li>
              </ul>
              <strong>Accounts</strong>
              <ul>
                <li>Updated send invoice email dialogs to allow CC only</li>
                <li>Send invoice email dialog now CC custom contact email by default (if specified in order)</li>
              </ul>
              <strong>General</strong>
              <ul>
                <li>Fixed issue with pressing enter key during text entry causing pages to reset/refresh</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.1.7</ContentTitle>
              <ContentSubTitle>28/05/2023</ContentSubTitle>
              <strong>Xero</strong>
              <ul>
                <li>Split up bank accounts for each payment type</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Fixed issue with edgework allowances breaking panel in very rare instances</li>
              </ul>
              <strong>General</strong>
              <ul>
                <li>Support for kiosk configuration</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Fixed start/end time and dates for delivery task wizard</li>
              </ul>
              <strong>Users</strong>
              <ul>
                <li>Added kiosk pickup label type to users</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.1.6</ContentTitle>
              <ContentSubTitle>22/05/2023</ContentSubTitle>
              <strong>Pricing</strong>
              <ul>
                <li>Fixed issue with editing price lists</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Added support for custom contact person details for orders with no fixed contact person</li>
                <li>Added support for adding order to pickup task</li>
              </ul>
              <strong>Users</strong>
              <ul>
                <li>Improved how permissions are displayed to show overrides</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.1.5</ContentTitle>
              <ContentSubTitle>18/05/2023</ContentSubTitle>
              <strong>Tasks</strong>
              <ul>
                <li>Updates to order list in new despatch task wizards</li>
              </ul>
              <strong>Inventory</strong>
              <ul>
                <li>Improved support for inactive glass sizes</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.1.4</ContentTitle>
              <ContentSubTitle>17/05/2023</ContentSubTitle>
              <strong>Orders</strong>
              <ul>
                <li>Added support for printing sheets at a different printer for orders link to a specific production stage</li>
                <li>Added support for skipping COD when scanning orders for despatch. Force complete production must be enabled to use</li>
                <li>Updates to orders list</li>
              </ul>
              <strong>Users</strong>
              <ul>
                <li>Added label support for users</li>
                <li>Added pickup system label available for users for future pickup task support</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.1.3</ContentTitle>
              <ContentSubTitle>10/05/2023</ContentSubTitle>
              <strong>Orders</strong>
              <ul>
                <li>Added support for forcing production complete during despatch scanning. See order settings to enable</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Updates to task system</li>
                <li>Added task events to automation system</li>
              </ul>
              <strong>Automations</strong>
              <ul>
                <li>Updates to automation system</li>
                <li>Updated contact communication actions in automation system</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.1.2</ContentTitle>
              <ContentSubTitle>21/04/2023</ContentSubTitle>
              <strong>Orders</strong>
              <ul>
                <li>Improved detection of all-round edgework for order editor items</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Updates to flow of delivery tasks</li>
                <li>Updates to new delivery wizard</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Major Update - v2.1.1</ContentTitle>
              <ContentSubTitle>19/04/2023</ContentSubTitle>
              <strong>General</strong>
              <ul>
                <li>Added ability to create a support ticket</li>
                <li>Added support ticket create permission</li>
                <li>Added support for multifactor authentication for users</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Fix for waterjet path calculations causing issues for complex panels</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Refactored task system to use specific task types</li>
                <li>New delivery / pickup task managers</li>
                <li>Added new delivery task creation wizard</li>
              </ul>
              <strong>Xero</strong>
              <ul>
                <li>Updated Xero config to support more options for syncing data to and from Xero</li>
              </ul>
              <strong>Users</strong>
              <ul>
                <li>Added support for multi-factor authentication for users</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Major Update - v2.1.0</ContentTitle>
              <ContentSubTitle>24/03/2023</ContentSubTitle>
              <strong>Optimiser</strong>
              <ul>
                <li>Fixes for orders going on stock hold when stock available</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Added process to expire old quotes waiting customer approval</li>
                <li>Added order &amp; quote settings as placeholders for message templates</li>
                <li>Fixed issue with arc cutting paths in optimisation for archtops and other small shapes with large arcs</li>
              </ul>
              <strong>Inventory</strong>
              <ul>
                <li>Fixed display of glass stock between sheets and offcuts</li>
                <li>Fixed logging of sales orders with stock transactions</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Added manual cutting scan sheet for stock associated with a cutting station</li>
                <li>Fixed optimiser job list for large number of sheets</li>
                <li>Added support for setting sheet info when automtaically creating sheets for panels</li>
                <li>Added support for sheet quantity when creating optimiser sheets</li>
              </ul>
              <strong>Users</strong>
              <ul>
                <li>Added headers to permission switches while editing</li>
                <li>Fixed issue with permission dependencies</li>
              </ul>
              <strong>Contacts</strong>
              <ul>
                <li>Force validation of email addresses for contact people</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.0.16</ContentTitle>
              <ContentSubTitle>23/02/2023</ContentSubTitle>
              <strong>Optimiser</strong>
              <ul>
                <li>Added additional optimiser settings in config</li>
                <li>Attempts to move panels out of the way if a panel's size (via custom trim) is increased in the optimiser editor</li>
                <li>Added point display on cutting lines when selecting points on cutting lines for relief cuts</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Added face / grain info for panels in review</li>
                <li>Fixed issue with cutting lines around edge/corner cutouts</li>
                <li>Fixed issue with cutting straight line through arcs</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Added default edgework items for standard order line items when editing</li>
              </ul>
              <strong>Intelligence</strong>
              <ul>
                <li>Added panels due to production breakdown report</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.0.15</ContentTitle>
              <ContentSubTitle>19/02/2023</ContentSubTitle>
              <strong>Production</strong>
              <ul>
                <li>Added additional panel checks when editing / cutting split sheets</li>
                <li>Added recut details for a recut panel in the main station popover</li>
                <li>Pre-Production panels removed from optimiser queue</li>
                <li>Updated search page for production stations</li>
                <li>Added order item notes to service list in production panel print labels</li>
                <li>Added ability to view offcut details &amp; print label after creating an offcut</li>
              </ul>
              <strong>Optimiser</strong>
              <ul>
                <li>Dragging panels into scratch pad in optimiser editor is now easier</li>
              </ul>
              <strong>Intelligence</strong>
              <ul>
                <li>Added stock filter to optimiser sheet chart</li>
                <li>Added production status breakdown to production report view</li>
                <li>Added purchase order status filters to stock re-order report</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Added recut label to production preview list</li>
                <li>Updates to support unicode (eg, emoji's) in order notes</li>
                <li>Revert to production function is now available for order administrators</li>
                <li>Added admin function to recheck production status for orders in production for order administrators</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Fixed issue with center cutouts having incorrect dimension datum points when the panel shape has been modified</li>
                <li>Fixed issue with placement of center cutouts near small side/corner cutouts</li>
                <li>Added edgework flags for order editor items for display on labels / reports</li>
                <li>Fixed cutouts being detected on basic arc type shapes</li>
                <li>Added additional descriptions for cutouts in review page</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.0.14</ContentTitle>
              <ContentSubTitle>09/02/2023</ContentSubTitle>
              <strong>Production</strong>
              <ul>
                <li>Cutouts at waterjet are automatically disabled if processed at optimisation</li>
                <li>Waterjet is completed automatically if all cutouts on a panel are processed at optimisation</li>
                <li>Updates to editor queue view</li>
                <li>Added order dialog in production to display order production preview</li>
                <li>Added ability to add an offcut from optimiser stock allocation page</li>
                <li>Added filter on optimiser stock allocation page</li>
                <li>Adding offcuts from production station will recheck all related orders on stock hold</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Updated to disable sheet printing when order is pending prepaid</li>
                <li>Fixed default zoom in the order editor</li>
                <li>Added pre-production options</li>
                <li>Fixed issue with panels in despatch status not getting new production tasks added after order item editing</li>
              </ul>
              <strong>Intelligence</strong>
              <ul>
                <li>Added daily completed sheet breakdown chart</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.0.13</ContentTitle>
              <ContentSubTitle>06/02/2023</ContentSubTitle>
              <strong>Production</strong>
              <ul>
                <li>New version of production batches for cutting stations</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.0.12</ContentTitle>
              <ContentSubTitle>02/02/2023</ContentSubTitle>
              <strong>Production</strong>
              <ul>
                <li>Fixed issue with optimiser export</li>
                <li>Added refresh button to station title bar</li>
                <li>Added urgent icon for panels of urgent orders in optimiser editor</li>
                <li>Added recut notes to panel popover in optimiser</li>
                <li>Added urgent order highlight to panel popover in optimiser</li>
                <li>Added ability to send sheets from optimisation breakout back to primary station</li>
                <li>Added ability to revert sheets in cutting back to editing in optimiser</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.0.11</ContentTitle>
              <ContentSubTitle>01/02/2023</ContentSubTitle>
              <strong>Production</strong>
              <ul>
                <li>Added ability to disable cutouts at waterjet station</li>
                <li>Fixed up v-cut type cutting lines at optimiser with a large trim on the same side</li>
                <li>Added optimiser sheet links from panel popover / panel page from orders</li>
                <li>Panel production stages completed will now be blacked out on panel label colour codes with inverse code</li>
                <li>Added reprint offcut label option to offcut dialog in production station</li>
                <li>Forced trim around arcs on panels in optimiser sheets</li>
                <li>Added pathfinding to optimiser cutouts for more efficient / better cutting paths</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.0.10</ContentTitle>
              <ContentSubTitle>24/01/2023</ContentSubTitle>
              <strong>Production</strong>
              <ul>
                <li>Improved diagram display on large production panels</li>
                <li>Added editor viewing of the general/feed production station panel queue list</li>
                <li>Updated optimiser processing for overdue panels</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Added tick display on panels if fully approved in review</li>
                <li>Added default that all panels are approved in review when loading an existing order</li>
                <li>Runouts containing side notches are now calculated correctly</li>
                <li>Added auto recovery system when creating larger orders. Saved recovery info can be restored to continue</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.0.9</ContentTitle>
              <ContentSubTitle>18/01/2023</ContentSubTitle>
              <strong>Production</strong>
              <ul>
                <li>Added ability to offset panel position on waterjet bed</li>
                <li>Panels calculate offset automatically for runouts against the origin guide</li>
                <li>Added ability to set height for inline relief cuts</li>
                <li>Fixed panels in scratch pad area for optimiser losing flipped setting</li>
                <li>Improved dimension display in optimiser editor</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.0.8</ContentTitle>
              <ContentSubTitle>16/01/2023</ContentSubTitle>
              <strong>Production</strong>
              <ul>
                <li>Added ability to add panel interior cutouts to optimiser cutting list</li>
                <li>Optimiser status sorted by unallocated panels first</li>
                <li>Added optimiser queue functions</li>
                <li>Improved waterjet cutout cutting order</li>
                <li>Added ability to modify cutting order for cutouts</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Fixed up cutout calculations that are joined to arcs</li>
                <li>Fixed up default corner radiuses to use correct glass type when checking guidelines</li>
                <li>Fixed up generation of panel shape used for waterjet placement</li>
              </ul>
              <strong>General</strong>
              <ul>
                <li>Fixed up issues with queries using search text</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.0.7</ContentTitle>
              <ContentSubTitle>11/01/2023</ContentSubTitle>
              <strong>Automations</strong>
              <ul>
                <li>Added order despatch type field to order status changed event</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Added trim settings for offcut specific source sheets in optimiser</li>
                <li>Added function to manually add offcuts from cutting station</li>
                <li>Updates to min spacing between panels in optimiser sheets</li>
                <li>Added trim to circles / ovals by default in optimiser</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.0.6</ContentTitle>
              <ContentSubTitle>9/01/2023</ContentSubTitle>
              <strong>Orders</strong>
              <ul>
                <li>Panels cancelled or skipped in NCR no longer show up in order editor review</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Fixed issue with split sheets in optimiser</li>
                <li>Added support for floating stages to be completed out of order</li>
                <li>Added more zoom features to optimiser editor</li>
                <li>Fixed issues with panels and reprint tags</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.0.5</ContentTitle>
              <ContentSubTitle>8/01/2023</ContentSubTitle>
              <strong>Order Editor</strong>
              <ul>
                <li>Merged edgeworks in review screen for ovals / circles</li>
                <li>Fixed calculation of edgework lines connected to arcs. Eg, archtops / d-ends</li>
                <li>Added display of edgework length in review sidebar</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Line items for stock with 2 sides now default to stock default</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Fixes for production panel colour codes</li>
                <li>Fixed optimiser sheet info panel getting data cutoff</li>
                <li>Stock with tracking quantities disabled no longer show up in optimiser status list</li>
                <li>Added orders schedule list to stations</li>
                <li>Added batch page to manual cutting + optimisation cutting stations</li>
                <li>Added zoom / pan support to optimiser sheet editor</li>
                <li>Added small / large queue item support for station app</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>
        </WhatsNewGroup>

        <WhatsNewGroup title="2022">
          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.0.4</ContentTitle>
              <ContentSubTitle>19/12/2022</ContentSubTitle>
              <strong>Order Editor</strong>
              <ul>
                <li>Guideline minimum values are now inclusive when testing for guideline warnings</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Added feed in production station type</li>
                <li>Added maximum feed height hardware setting to feed in production stations</li>
                <li>Edgework in orders will cause a production warning if the edgework exceeds max feed height for feed in type edgework stations</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.0.3</ContentTitle>
              <ContentSubTitle>16/12/2022</ContentSubTitle>
              <strong>Orders</strong>
              <ul>
                <li>Added orders system label type for contact people. Used for default selection of people to email order details</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Updated edgework allowance to support lines and arcs</li>
              </ul>
              <strong>Optimisation</strong>
              <ul>
                <li>Updates to optimiser editor</li>
                <li>Added handcut flag to glass items for optimiser</li>
              </ul>
              <strong>Automations</strong>
              <ul>
                <li>Updates to automations to clean up the system</li>
                <li>Added send order email action</li>
                <li>Added order status updated event</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.0.2</ContentTitle>
              <ContentSubTitle>9/12/2022</ContentSubTitle>
              <strong>Production</strong>
              <ul>
                <li>Added info button to panels in the queue at a station</li>
              </ul>
              <strong>Order</strong>
              <ul>
                <li>Removed reset purchase orders dialog if no purchase orders have been created</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Improved size detection of circle panels or panels with large arcs</li>
              </ul>
              <strong>Inventory</strong>
              <ul>
                <li>Added satinlite &amp; spotswood glass textures</li>
                <li>Updated block print label to be consistent with other labels</li>
              </ul>
              <strong>Intelligence</strong>
              <ul>
                <li>Added daily order average to orders intelligence report</li>
                <li>Updated order reports to be much more optimised for large data sets</li>
                <li>Updated order widget to include total glass panels ordered</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>
          
          <div class="row">
            <div class="col-12">
              <ContentTitle>Minor Update - v2.0.1</ContentTitle>
              <ContentSubTitle>28/11/2022</ContentSubTitle>
              <strong>Orders</strong>
              <ul>
                <li>Fixed issue with order line items having units reset after using order editor</li>
                <li>Improved split tool in order editor</li>
                <li>Fixed cancelled order items having new panels created via purchase order receiving</li>
                <li>Added additional checks for over-invoicing orders with an incorrect number of panels</li>
              </ul>
              <strong>Inventory</strong>
              <ul>
                <li>Added default side up option for glass stock</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Added face side up to large print labels</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>Major Update - v2.0.0</ContentTitle>
              <ContentSubTitle>16/11/2022</ContentSubTitle>
              <strong>Orders</strong>
              <ul>
                <li>Fixed orders with only delivery item not being invoiced</li>
                <li>Added NCR order list display for orders with NCRs generated</li>
                <li>Added support to import documents from source order when copying an order / creating an NCR</li>
                <li>Stock only orders now go through pending production step</li>
                <li>Fixed issue with editing order despatch delivery stock and then order items list</li>
                <li>Fixed quotes in draft mode getting stuck in pending approval state</li>
                <li>Date estimates / requested date options disabled for quotes in new order screen</li>
                <li>Fixed issue with stepped glass items inside a template resetting sizes while editing</li>
                <li>Pre-paid orders with a requested date have a grace period to accept payment, or requested date is reset</li>
                <li>Order production is scheduled from when accounts approval is actioned, if after scheduled start date</li>
                <li>Order production is scheduled from when pre-payment is settled, if after scheduled start date</li>
                <li>Fixed support for cancelling templated order items (eg, IGUs)</li>
                <li>Added display of NCR accounts showing generated invoices / credit notes after NCR completion</li>
                <li>Added fixes for editing order items in despatch state</li>
                <li>Added support for NCR repair flag for order items</li>
                <li>Added support for remake/repair quantities when creating NCRs</li>
                <li>Added support for editing external items/order offers option to reset existing purchase orders</li>
                <li>Added option to re-check external purchase orders if orders are stuck in external setup</li>
                <li>Fixed issue with panels with no production stages not moving the order to despatch</li>
                <li>Fixed issue with order items switching between external/not-external and not correctly adjusting panels/tasks</li>
                <li>Added production query for order items, so external order items are flagged external automatically</li>
                <li>Fixed display of corners with very small angle showing up as squared corners</li>
                <li>Moved order settings into a seperate order configuration admin page</li>
                <li>Added order item rules configuration to automatically add order items to order item groups based on rules</li>
                <li>Added order setting to control if panel previews are displayed in order documents</li>
                <li>Scanning order despatch list now processes orders for despatch with a more responsive flow</li>
                <li>Added order setting to control what stock to use to flag panels with template handling required</li>
                <li>Added payments made &amp; amount due total to order document pdf for orders with over payments assigned</li>
                <li>Added option to enable/disable pending production status for orders</li>
                <li>Fixed issue with panel preview diagrams showing up multiple times after editing item list</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Added support to convert a rounded corner to an arc</li>
                <li>Added configuration for maximum distance for snapping straight line cut from glass edge</li>
                <li>Fixed detection of corner cutouts</li>
                <li>Fixed detection consecutive perfect arcs for shape price type</li>
                <li>Fixed overall size calculation for large arcs</li>
                <li>Fixed rounding of radius for circle holes in templates</li>
                <li>Fixed custom edge cutouts with included holes adding holes in the wrong position</li>
                <li>Added review process to confirm order editor panel details before finishing the editor</li>
                <li>Fixed up issues with cutting circles resting on edges of other cutouts</li>
                <li>Fixed up issues with straight line cutting tool when the line is on a corner of the panel</li>
                <li>Fixed up issues with a group containing multiple cutouts using stock overrides that would create multiple quantities for each overidden stock</li>
                <li>Added function to convert an arc to a corner radius</li>
              </ul>
              <strong>Purchasing</strong>
              <ul>
                <li>Added ability to approve purchase order amendments and go back to the previous status</li>
                <li>Added ability to set custom sizes for bulk purchase order glass items</li>
                <li>Add ability to email cancelled purchase orders, with cancelled stamp/header on the PDF</li>
                <li>Add ability to email purchase orders in more states</li>
                <li>Fixed calculation of sheets received for blocks in standard purchase orders</li>
              </ul>
              <strong>Misc</strong>
              <ul>
                <li>Added 'Hide Hold' filter button to production station schedule list</li>
                <li>Added support for resending communication logs for users with the resend comm permission</li>
                <li>Added ability to move back to counting for stocktakes in review/recount state</li>
                <li>Fixed incorrect error display in add payment dialog</li>
                <li>Fixed support for panel listing/scanning for panels from orders in denied or pending approval state</li>
                <li>Added NCR notes to production station panel popover</li>
                <li>Added searching payment receiveds by payment number</li>
                <li>Added order entry duration chart to orders intelligence page</li>
                <li>Split up user &amp; order charts in orders intelligence page</li>
                <li>Updated daily order breakdown chart in order intelligence</li>
                <li>Updated main dashboard with an updated system overview panel</li>
                <li>Added ability to edit details for a payment received</li>
                <li>Updated print label configurations</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>v1.1.5</ContentTitle>
              <ContentSubTitle>31/03/2022</ContentSubTitle>
              <strong>Intelligence</strong>
              <ul>
                <li>Added detailed sales summary report</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Fixed issue with center cutout circles adjusting default size incorrectly</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Added check to ignore cancelled order items in approvals</li>
              </ul>
              <strong>Misc</strong>
              <ul>
                <li>Fixed error with stocktake display when changing from review to recount</li>
                <li>Fixed error when typing emoticons into datatable search field</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>v1.1.4</ContentTitle>
              <ContentSubTitle>29/03/2022</ContentSubTitle>
              <strong>Order Editor</strong>
              <ul>
                <li>Performance updates</li>
                <li>Updated positions of auto-arrange tool</li>
                <li>Updated move controls for panel items / center cutouts / panels</li>
                <li>Added center / edge option to corner cutouts</li>
                <li>Added dimension editing when adding corner cutouts</li>
                <li>Added support for order documents list via order editor</li>
                <li>Fixed center cutout hole radius/diameter rounding</li>
                <li>Fixes to calculations of straight line cuts for large panels with small runouts</li>
                <li>Fixes to add points tool</li>
                <li>Small updates to dimension display during selections</li>
                <li>Fixed DXF output for arcs</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Improved performance during order item creation/editing</li>
                <li>Added ability to update NCR labels for order items during order item updates</li>
                <li>Added delivery tag to orders list</li>
                <li>Added display of payments made / amount due on order payment dialog</li>
              </ul>
              <strong>Purchasing</strong>
              <ul>
                <li>Improved spacing on purchase order PDF</li>
                <li>Added date required to purchase order list</li>
                <li>Added ability to edit reference info for bulk purchase orders</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Added ability to add production station from product stage page</li>
                <li>Added feedback on production station label reprint</li>
                <li>Fixed scrolling of content in revert panel dialog</li>
              </ul>
              <strong>Misc</strong>
              <ul>
                <li>Improved server access performance</li>
                <li>Small fix to permission system</li>
                <li>Billing page updates</li>
                <li>Communication logs now store additional uploaded files from email form</li>
                <li>Added search support for order / invoice allocation list with payment receiveds</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>v1.1.3</ContentTitle>
              <ContentSubTitle>25/02/2022</ContentSubTitle>
              <strong>Order Editor</strong>
              <ul>
                <li>Added support for oval shaped panels</li>
                <li>Added checks to disable shape editing / cutouts for circle/oval shaped panels</li>
                <li>Improved circle panel size editing support</li>
                <li>Improved detection of shape types for shapes with arcs</li>
                <li>Improved support of arcs in polylines when importing DXF files</li>
                <li>Added support for center cutouts within circle and oval shapes</li>
                <li>Added support for oval center cutouts</li>
                <li>Updated moving of panel items</li>
                <li>Added square angle display in output SVGs</li>
                <li>Improved corner radius support in DXF exports</li>
                <li>Added support for combining multiple center cutouts into a single cutout</li>
                <li>Added ability to reset a glass panel back to standard shape</li>
                <li>Added auto-arrange button for glass panels</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Improved corner radius support in DXF exports in waterjet</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>v1.1.2</ContentTitle>
              <ContentSubTitle>15/02/2022</ContentSubTitle>
              <strong>Orders</strong>
              <ul>
                <li>Added mark as to order PDF output</li>
                <li>Moved diagrams &amp; panel list to bottom of groups in order PDF output</li>
                <li>Cleanup to order PDF output</li>
                <li>Added order viewer to show order without editing</li>
              </ul>
              <strong>Intelligence</strong>
              <ul>
                <li>Added customer pricing report tool</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>v1.1.1</ContentTitle>
              <ContentSubTitle>13/01/2022</ContentSubTitle>
              <strong>Order Editor</strong>
              <ul>
                <li>Improved detection of edge vs corner cutout types</li>
                <li>Improved detection of straight line cuts</li>
                <li>Added ability to view order in the editor without editing an order</li>
                <li>Added ability to export DXF from the order editor</li>
                <li>Added more dimensioning in cutting view type</li>
                <li>Fixed diameter settings in circle center cutouts</li>
                <li>Added support for default edgework when importing DXF shapes</li>
                <li>Updated panel items support</li>
                <li>Added 'apply default' support to panel items</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Fixes to waterjet exporting</li>
                <li>Enabled thumbnail view</li>
                <li>Increased precision on DXF output from waterjet</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>v1.1.0</ContentTitle>
              <ContentSubTitle>7/01/2022</ContentSubTitle>
              <strong>Order Editor</strong>
              <ul>
                <li>Simple circle cutouts can now be converted to an edge/corner cutout template</li>
                <li>Order editor now supports editing NCR orders correctly</li>
                <li>Cutout templates can now be measured to edge</li>
                <li>Fixes when updating editing dimensions in line tools</li>
                <li>Fixes when editing existing order items</li>
              </ul>
              <strong>Order</strong>
              <ul>
                <li>Unit Price override now persisted in order items for orders and purchase orders</li>
              </ul>
              <strong>General</strong>
              <ul>
                <li>Added help popup for permissions</li>
                <li>Updates to pricing module permissions</li>
                <li>Updates to purchasing module permissions</li>
                <li>Updated billing details page</li>
                <li>Migrated to app.synsoft.com.au</li>
                <li>Major cloud platform upgrades and performance optimisations</li>
              </ul>            
              <FormHorizontalRule />
            </div>
          </div>
        </WhatsNewGroup>

        <WhatsNewGroup title="2021">
          <div class="row">
            <div class="col-12">
              <ContentTitle>v1.0.21</ContentTitle>
              <ContentSubTitle>20/12/2021</ContentSubTitle>
              <strong>Order Editor</strong>
              <ul>
                <li>Fixes to mark as / notes editing on panels</li>
                <li>Added support for edgework on arcs</li>
                <li>Added polished flag for vertices</li>
                <li>Fixed size description on center cutouts in order items</li>
                <li>Fixes to selecting objects</li>
                <li>Added stock overrides to groups</li>
                <li>Fixed up edgework cost calculation</li>
                <li>Fixed detection of corner vs edge cutouts</li>
                <li>Fixed straight line cut detection</li>
                <li>Fixed issue with panels with runouts causing issues with cutouts</li>
              </ul>
              <strong>Order</strong>
              <ul>
                <li>Enabled order diagrams for preview for editor / standard items</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>v1.0.20</ContentTitle>
              <ContentSubTitle>15/12/2021</ContentSubTitle>
              <strong>Orders</strong>
              <ul>
                <li>Fixes for item layout in order PDFs</li>
                <li>System administrators can now edit order item stock/sizes if associated panels are already cut</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>v1.0.19</ContentTitle>
              <ContentSubTitle>14/12/2021</ContentSubTitle>
              <strong>Orders</strong>
              <ul>
                <li>Updated secondary description (eg, Toughened) font on production sheets</li>
              </ul>
              <strong>Order Editor</strong>
              <ul>
                <li>Fixed issues with creating/updating edgework configuration</li>
              </ul>
              <strong>Admin</strong>
              <ul>
                <li>Updated admin tools</li>
                <li>Added admin export tools</li>
                <li>Moved subscription / billing info into seperate page</li>
              </ul>
              <strong>Intelligence</strong>
              <ul>
                <li>Updated order value report page</li>
                <li>Added quote info to order value report page</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Fixed NCR group counts in panel schedule</li>
              </ul>
              <strong>Help</strong>
              <ul>
                <li>Creation of help module</li>
                <li>Moved this page to help module</li>
              </ul>
              <strong>General</strong>
              <ul>
                <li>Fixed upload of files containing invalid characters</li>
                <li>Fixed support for unicode characters in activity log (eg, emoticons)</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>v1.0.18</ContentTitle>
              <ContentSubTitle>4/10/2021</ContentSubTitle>
              <strong>Pricing</strong>
              <ul>
                <li>Fixed rate selection popover in customer price list preview dialog</li>
                <li>Added unload detection while editing customer price list to price request page</li>
                <li>Added sequence numbers to price update requests</li>
                <li>Fixed status display of price update requests</li>
                <li>New customer price lists now have options available to select how to combine new price lists with pending price updates</li>
                <li>Added simple / complex pricing system types that controls how pricing works for customers</li>
                <li>Linked customer price lists displayed in the data source price request</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Added ability to edit order items for stock orders in pending COD status</li>
                <li>Changed the order created data in the order data table to use the same date field as reports (when orders created / converted to order from quote)</li>
                <li>Added NCR details for order items in order report sheets</li>
                <li>Fixed percent of order line items price updating incorrectly</li>
                <li>Fixed percent of order line items price not updating when order items cancelled</li>
                <li>Updates for minimum charge/invoice items when order items cancelled</li>
                <li>Added force complete production system admin function</li>
                <li>Added skip pending order system admin function</li>
                <li>Added revert order despatch system admin function</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Fixed scanning of panels at cutting that have been reverted back to cutting</li>
                <li>Fixed NCR group count in panel schedule showing wrong number of panels flagged with NCR</li>
                <li>Fixed reverting panel stage tasks if order is in pending COD</li>
                <li>Fixed stock level display at cutting station</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>Resource view in task manager adjusted to show in 15min increments</li>
              </ul>
              <strong>Intelligence</strong>
              <ul>
                <li>Glass stock on hand data table now shows sizes correctly (was width x height)</li>
                <li>Added export options to stock on hand data tables</li>
              </ul>
              <strong>General</strong>
              <ul>
                <li>Added support for scrollable popovers</li>
                <li>Fixed large groups of items (eg, templates) in report PDFs creating blank pages</li>
                <li>Moved order item secondary description to 2nd line in report PDFs to prevent long descriptions pushing pricing off page. Applied to orders, invoices and purchase orders</li>
                <li>Added scrolling to large lists of labels in popover (eg, recut labels)</li>
                <li>Added unload detection while creating new customers</li>
                <li>Reduced time users are locked out after 10 failed attempts</li>
                <li>Module specific config menu items are all now under Admin menu</li>
                <li>Fixed item count per page in customer account statements</li>
                <li>Added line numbers / total invoice count to customer account statements</li>
                <li>Added system administrator permission</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>v1.0.17</ContentTitle>
              <ContentSubTitle>06/06/2021</ContentSubTitle>
              <strong>Orders</strong>
              <ul>
                <li>Minimum price charge now takes into account glass and all child order items</li>
                <li>Services can now be added to stock linked order items</li>
                <li>Updates to minimum item price and minimum invoice pricing in orders</li>
                <li>Can now print production labels during pending COD status</li>
              </ul>
              <strong>Pricing</strong>
              <ul>
                <li>Archived stock items hidden in customer price list configuration</li>
                <li>Fixed rounding issue in payment received dialog when paying invoices and orders</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Added production administrator user permission</li>
                <li>Added feature to revert panel production tasks completed</li>
              </ul>
              <strong>Purchasing</strong>
              <ul>
                <li>Showed notes for non-bulk purchase order items in the purchase order PDF</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>v1.0.16</ContentTitle>
              <ContentSubTitle>21/05/2021</ContentSubTitle>
              <strong>Inventory</strong>
              <ul>
                <li>Glass blocks no longer count towards inventory glass sheet totals in the system</li>
                <li>Existing glass blocks have been added as loose sheets</li>
              </ul>
              <strong>Pricing</strong>
              <ul>
                <li>Added support to edit stock sales prices in price request group in draft mode</li>
                <li>Added include unchanged prices in bulk modifiers</li>
                <li>Updates to price list editing to display previous data</li>
                <li>Split up stock sales prices in price request into multiple tabs</li>
                <li>Added tab to show unchanged stock sales prices</li>
                <li>Stock sales prices are displayed as datatables in a price request</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>When changing order items stock code to an each type (from another type), order entry now resets units / edgework settings</li>
              </ul>
              <strong>Misc</strong>
              <ul>
                <li>Updates to item lists on some PDF reports not wrapping across after the first page</li>
                <li>Added popover the production report in intelligence to display panel list</li>
                <li>Added support for future dates 'As At' in the aged receivables reporting</li>
                <li>Data table PDF export now downloads the PDF</li>
                <li>Data table export now does no pagination</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>


          <div class="row">
            <div class="col-12">
              <ContentTitle>v1.0.15</ContentTitle>
              <ContentSubTitle>29/04/2021</ContentSubTitle>
              <strong>Core</strong>
              <ul>
                <li>Added support for CSV &amp; PDF export for various data tables</li>
                <li>Added support to select what column to filter dates by in data tables</li>
                <li>Added manual stock usage entry page to admin area</li>
              </ul>
              <strong>Purchasing</strong>
              <ul>
                <li>Moved purchase order data table columns</li>
                <li>Added Stock Reorder Report tab to purchasing intelligence page</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Improved performance of the order list</li>
                <li>Added duplicate customer reference check to order creation wizard</li>
              </ul>
              <strong>Pricing</strong>
              <ul>
                <li>Moved stock price group customer overrides to be now linked to customer price lists</li>
                <li>Merged bulk price tool into price request</li>
                <li>Added bulk price items as price modifiers &amp; stored in price request</li>
              </ul>
              <strong>Inventory</strong>
              <ul>
                <li>Converted stock transaction list to a full datatable view with more features</li>
                <li>Added summaries to stocktake count data tables</li>
                <li>Added error display for stocktake items</li>
                <li>Added activity logs for submitted stocktake counts</li>
                <li>General stocktake improvements</li>
              </ul>
              <strong>Misc</strong>
              <ul>
                <li>Fixed sheets on hand display in cutting dialog in production cutting station</li>
                <li>Updated orders intelligence page charts &amp; added more chart types</li>
                <li>Fixed text wrapping in service items on production panel labels</li>
                <li>Added invoice intelligence page with basic details &amp; daily chart</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>v1.0.14</ContentTitle>
              <ContentSubTitle>2/04/2021</ContentSubTitle>
              <strong>Core</strong>
              <ul>
                <li>Updated system settings in seperate page</li>
              </ul>
              <strong>Tasks</strong>
              <ul>
                <li>General fixes &amp; updates to task system</li>
                <li>Completely updated task app scanning process</li>
                <li>Added legend popover for map &amp; calendar views</li>
                <li>Added resource filter for resource &amp; month calendar views</li>
              </ul>
              <strong>Accounts</strong>
              <ul>
                <li>Fixed credit note Xero link</li>
                <li>Fixed rounding precision issue with order allocations for payments</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Added despatch docket for task despatch</li>
                <li>Removed old SVG generation data from order entry wizard</li>
                <li>Added fix to move an order back into production if the last panel has been recut</li>
                <li>Added support for minimum invoice line item</li>
              </ul>
              <strong>Pricing</strong>
              <ul>
                <li>Added option to enable/disable automatic generation of price lists for sales price updates</li>
                <li>Added types to price requests</li>
                <li>Update price request list to used datatable with filters</li>
                <li>Updates to price request system to only allow 1 pending sales price request at a time</li>
                <li>Added draft mode to price requests</li>
                <li>Added support for minimum invoice charge to price groups and stock</li>
                <li>Added customer price group pricing overrides</li>
                <li>Other misc updates to price request and price lists</li>
                <li>Updates to bulk price tool</li>
              </ul>
              <strong>Production</strong>
              <ul>
                <li>Added production panel page &amp; listing</li>
                <li>Improved production panel activity logging during production</li>
              </ul>
              <strong>Intelligence</strong>
              <ul>
                <li>Improved performance of NCR, Recut and Orders summary widgets</li>
              </ul>
              <strong>Misc</strong>
              <ul>
                <li>Stock levels 'On Order' now consider purchase orders in status pending shipping</li>
                <li>Fixed due date on production label to match order sheet</li>
                <li>Added barcode to production scanning error message on station app</li>
                <li>Added completed / cancelled date column to purchase order data table</li>
                <li>Fixed PDF documents with items splitting across multiple pages</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <ContentTitle>v1.0.13</ContentTitle>
              <ContentSubTitle>12/02/2021</ContentSubTitle>
              <strong>Accounts</strong>
              <ul>
                <li>Added credit note receipt</li>
                <li>Added send credit note receipt support</li>
              </ul>
              <strong>Contacts</strong>
              <ul>
                <li>Added delivery tag label to address in create contact page</li>
              </ul>
              <strong>Intelligence</strong>
              <ul>
                <li>Added today&apos;s invoices widget. Invoice summary page still in progress</li>
                <li>Added the day&apos;s station performance graphs to the production performance page</li>
              </ul>
              <strong>Orders</strong>
              <ul>
                <li>Order Cancellation now charges services that are reached (but not started)</li>
                <li>Order Cancellation now charges services without associated production stages if any linked panels have started production</li>
                <li>Order despatch editing has a seperate dialog now</li>
                <li>Updated edit order despatch to include address dropdown &amp; delivery tags</li>
                <li>Updated edit order to include urgent details</li>
                <li>New order page scrolls up to display errors during order creation</li>
              </ul>
              <FormHorizontalRule />
            </div>
          </div>
        </WhatsNewGroup>
      </TabPage>
    </template>
  </TabbedBox>
</template>

<style scoped>
.whats-new-upcoming {
  border: 1px solid #f0f0f0;
  padding: 0.75em;
  margin: 5px;
  border-radius: 20px;
}
</style>

<script>
import WhatsNewGroup from '@/modules/support/components/whatsNewGroup'

export default {
  name: 'WhatsNew',
  components: {
    WhatsNewGroup
  },
  mounted() {
    // Update last viewed build version
    localStorage.setItem('app-changelogview-lastbuild', process.env.VERSION)
    this.$store.commit('profile/setChangeLogUpdated', false)
  }
  
}
</script>